// 20-5-2026

// import {
//   Box,
//   Container,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   Switch,
//   Typography,
// } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import Row from 'react-bootstrap/esm/Row';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useParams } from 'react-router-dom';
// import { GetOneClientAction, UpdateClientAction } from '../Redux/Actions/UsersAction';
// import { Notify } from '../Utility/Notify';
// import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
// import EditIcon from '@mui/icons-material/Edit';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// // import MultiImageInput from 'react-multiple-image-input';
// // import { light } from '@mui/material/styles/createPalette';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
// import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
// import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
// import { Col } from 'react-bootstrap';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import { parsePhoneNumberFromString } from 'libphonenumber-js';
// // import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
// import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { useTheme } from '@mui/material/styles';
// import CircularProgress from '@mui/material/CircularProgress';

// export const UpdateClient = () => {
//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / light)
//   const { id } = useParams();
//   const dispatch = useDispatch();

//   const [submitLoading, setSubmitLoading] = useState(false);

//   //date
//   //===========================================================
//   const [date, setDate] = useState('');
//   const [dateonly, setDateonly] = useState('');

//   useEffect(() => {
//     //date and time
//     const today = new Date();
//     const formattedDateandtime = today.toLocaleDateString(); // يمكنك تخصيص التنسيق هنا
//     setDate(formattedDateandtime);

//     //date only
//     const todaydayonly = new Date();
//     // تنسيق التاريخ: yyyy-MM-dd
//     const formattedDateonly = `${todaydayonly.getFullYear()}-${(todaydayonly.getMonth() + 1)
//       .toString()
//       .padStart(2, '0')}-${todaydayonly.getDate().toString().padStart(2, '0')}`;
//     setDateonly(formattedDateonly); // تخزين التاريخ في الـ state
//   }, []);

//   //state of fields
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   // const [phone, setPhone] = useState('')
//   const [note, setNote] = useState('');
//   const [project, setproject] = useState('');
//   const [loading, setloading] = useState(true);
//   // const [location,setlocation]=useState('')
//   const [salesdata, setsalesdata] = useState('');
//   // const [images, setImages] = useState([]);
//   const [stage, setstage] = useState('');
//   const [Channal, setchannal] = useState('');
//   const [Communicationway, setcommunicationwat] = useState('');
//   const [budget, setbudget] = useState(0);
//   const [checked, setChecked] = useState(true);
//   const [Leedtype, setLeedtype] = useState('');
//   const [campaignid, setcampaignid] = useState('');
//   const [jobDescription, setJobDescription] = useState('');

//   //phone
//   const [value, setValue] = useState();
//   const [phonenumber2, setphonenumber2] = useState();
//   const [whatsappnumber, setwhatsappnumber] = useState();

//   const [Errorphonenumber2, setErrorphonenumber2] = useState('');
//   const [whatsappnumbererror, setwhatsappnumbererror] = useState('');

//   const [error, setError] = useState('');

//   const [countryName, setCountryName] = useState('');
//   const [selectedcountry, setselectedcountry] = useState('');
//   const handlePhoneChange = (newValue, countryData) => {
//     setValue(newValue);
//     setError(''); // إلغاء الخطأ عند الكتابة
//     if (countryData) {
//       setCountryName(countryData.name); // استرجاع اسم الدولة من countryData
//     }
//   };
//   useEffect(() => {
//     setselectedcountry(countryName);
//   }, [countryName]);

//   const handleBlur = () => {
//     // تحقق من صحة الرقم بعد ترك الحقل
//     const phoneNumber = parsePhoneNumberFromString(`+${value}`);
//     if (phoneNumber && phoneNumber.isValid()) {
//       setError(''); // الرقم صحيح، لا توجد أخطاء
//     } else {
//       setError('Please enter a valid phone number'); // رقم غير صالح
//     }
//   };

//   //==================================================

//   const handlePhone2Change = (newValue) => {
//     setphonenumber2(newValue);
//     setErrorphonenumber2(''); // إلغاء الخطأ عند الكتابة
//     // if (countryData) {
//     // setCountryName(countryData.name); // استرجاع اسم الدولة من countryData
//     // }
//   };

//   const handlewhatsappnumberChange = (newValue) => {
//     setwhatsappnumber(newValue);
//     setwhatsappnumbererror(''); // إلغاء الخطأ عند الكتابة
//     // if (countryData) {
//     // setCountryName(countryData.name); // استرجاع اسم الدولة من countryData
//     // }
//   };

//   const handleBlurphonenumber2 = () => {
//     // تحقق من صحة الرقم بعد ترك الحقل
//     const phoneNumber2 = parsePhoneNumberFromString(`+${phonenumber2}`);
//     if (phoneNumber2 && phoneNumber2.isValid()) {
//       setErrorphonenumber2(''); // الرقم صحيح، لا توجد أخطاء
//     } else {
//       setErrorphonenumber2('Please enter a valid phone number 2'); // رقم غير صالح
//     }
//   };

//   const handleBlurwhatsappnumber = () => {
//     // تحقق من صحة الرقم بعد ترك الحقل
//     const whatsappNumber = parsePhoneNumberFromString(`+${whatsappnumber}`);
//     if (whatsappNumber && whatsappNumber.isValid()) {
//       setwhatsappnumbererror(''); // الرقم صحيح، لا توجد أخطاء
//     } else {
//       setwhatsappnumbererror('Please enter a valid whatsapp number '); // رقم غير صالح
//     }
//   };

//   const handleChange = (event) => {
//     setChecked(event.target.checked);
//   };

//   useEffect(() => {
//     if (checked === true) {
//       setLeedtype('Fresh');
//     } else {
//       setLeedtype('Cold');
//     }
//   }, [checked]);
//   //==============get  data for one user or selected user=========================
//   useEffect(() => {
//     const rungetoneclientdata = async () => {
//       await dispatch(GetOneClientAction(id));
//       await dispatch(GetallProjectsdata());
//       await dispatch(Get_All_Sales_Action());

//       await dispatch(GetAll_stage_Data());
//       await dispatch(GetAllchannalData());
//       await dispatch(GetCommunicationwayData());
//       await dispatch(GetAllCampainData());
//     };
//     rungetoneclientdata();
//   }, []);

//   const resone_user_data = useSelector((state) => state.Allusers.Get_users);
//   const resGetProjectsData = useSelector((state) => state.AllProjects.Projects);

//   const resgetallstages = useSelector((state) => state.Allstages.stage);
//   const resgetallchannal = useSelector((state) => state.AllChannalRoot.channal);
//   const resgetallcommunicationway = useSelector(
//     (state) => state.AllCommunicationway.communicationway,
//   );
//   const resgetcampaindata = useSelector((state) => state.AllCampaign.campaign);

//   let res_getallstages_array = Array.isArray(resgetallstages?.data) ? resgetallstages.data : [];
//   let res_getallchannal_array = Array.isArray(resgetallchannal?.data) ? resgetallchannal.data : [];
//   let res_getallcommunicationway_array = Array.isArray(resgetallcommunicationway?.data)
//     ? resgetallcommunicationway.data
//     : [];
//   let res_get_campaign_data_array = Array.isArray(resgetcampaindata?.data)
//     ? resgetcampaindata.data
//     : [];

//   let one_user_data = [];
//   if (resone_user_data && resone_user_data.data) {
//     one_user_data = resone_user_data.data;
//   } else {
//     one_user_data = [];
//   }

//   //================================get all projects
//   let get_all_Projects_data = [];

//   if (resGetProjectsData && resGetProjectsData.data) {
//     get_all_Projects_data = resGetProjectsData.data;
//   } else {
//     get_all_Projects_data = [];
//   }

//   // /==================================================
//   // useEffect(()=>{
//   //     if(one_user_data)
//   //     {
//   //     setName(one_user_data?.name)
//   //     setEmail(one_user_data?.email)
//   //     // setPhone(one_user_data.phone)
//   //     const fetchedData = one_user_data?.phone;  // استبدل هذا بالبيانات المسترجعة (مثال فقط)

//   //     if (fetchedData) {
//   //       setValue(fetchedData.toString());  // تأكد من تحويل الرقم إلى نص
//   //     } else {
//   //       setValue(''); // في حالة عدم وجود بيانات، قم بتعيين قيمة فارغة
//   //     }

//   //       const fetchedDataphone2 = one_user_data?.phonenumber2;  // استبدل هذا بالبيانات المسترجعة (مثال فقط)

//   //     if (fetchedDataphone2) {
//   //       setphonenumber2(fetchedDataphone2.toString());  // تأكد من تحويل الرقم إلى نص
//   //     } else {
//   //       setphonenumber2(''); // في حالة عدم وجود بيانات، قم بتعيين قيمة فارغة
//   //     }

//   //       const fetchedDatawhatsappnumber = one_user_data?.whatsappnumber;  // استبدل هذا بالبيانات المسترجعة (مثال فقط)

//   //     if (fetchedDatawhatsappnumber) {
//   //       setwhatsappnumber(fetchedDatawhatsappnumber.toString());  // تأكد من تحويل الرقم إلى نص
//   //     } else {
//   //       setwhatsappnumber(''); // في حالة عدم وجود بيانات، قم بتعيين قيمة فارغة
//   //     }

//   //     setJobDescription(one_user_data?.jobdescription)
//   //     setNote(one_user_data?.notes)

//   //     if(one_user_data?.project)
//   //     {
//   //      setproject(one_user_data?.project._id)
//   //     }

//   //     if(one_user_data?.sales)
//   //     {
//   //         setsalesdata(one_user_data?.sales._id)
//   //     }

//   //     if(one_user_data&&one_user_data?.stage)
//   //       {

//   //         setstage(one_user_data?.stage?._id)
//   //       }

//   //     if(one_user_data&&one_user_data?.communicationway)
//   //     {

//   //       setcommunicationwat(one_user_data?.communicationway._id)
//   //     }

//   //     if(one_user_data&&one_user_data?.campaign)
//   //       {

//   //         setcampaignid(one_user_data?.campaign._id)
//   //       }

//   //      if(one_user_data?.chanel)
//   //       {

//   //         setchannal(one_user_data?.chanel._id)
//   //       }

//   //       setbudget(one_user_data?.budget)
//   //       setCountryName(one_user_data?.countryname)

//   //       if(one_user_data?.leedtype==='Fresh')
//   //       {
//   //         setChecked(true)
//   //       }
//   //       else
//   //       {
//   //         setChecked(false)
//   //       }

//   //     }

//   // },[one_user_data])

//   useEffect(() => {
//     // لو الـ data فعلاً جايه من السيرفر ومش فاضيه
//     if (one_user_data && Object.keys(one_user_data).length > 0) {
//       setName(one_user_data?.name || '');
//       setEmail(one_user_data?.email || '');
//       setValue(one_user_data?.phone?.toString() || '');
//       setphonenumber2(one_user_data?.phonenumber2?.toString() || '');
//       setwhatsappnumber(one_user_data?.whatsappnumber?.toString() || '');
//       setJobDescription(one_user_data?.jobdescription || '');
//       setNote(one_user_data?.notes || '');
//       setproject(one_user_data?.project?._id || '');
//       setsalesdata(one_user_data?.sales?._id || '');
//       setstage(one_user_data?.stage?._id || '');
//       setcommunicationwat(one_user_data?.communicationway?._id || '');
//       setcampaignid(one_user_data?.campaign?._id || '');
//       setchannal(one_user_data?.chanel?._id || '');
//       setbudget(one_user_data?.budget || 0);
//       setCountryName(one_user_data?.countryname || '');
//       setChecked(one_user_data?.leedtype === 'Fresh');
//     }
//   }, [one_user_data]);

//   //=======================================================
//   //on changes event of all fields
//   // =======================================================

//   const onjobdescriptionchange = (e) => {
//     setJobDescription(e.target.value);
//   };
//   const onnamechange = (e) => {
//     setName(e.target.value);
//   };

//   const onemailchange = (e) => {
//     setEmail(e.target.value);
//   };

//   const oncampaignidchange = (e) => {
//     setcampaignid(e.target.value);
//   };

//   const onnotechange = (e) => {
//     setNote(e.target.value);
//   };

//   const onprojectchange = (e) => {
//     setproject(e.target.value);
//   };
//   //===================================================
//   const onsaleschange = (e) => {
//     setsalesdata(e.target.value);
//   };

//   // const onlocationchange=(e)=>{
//   //   setlocation(e.target.value)
//   //   }

//   const onstagechange = (e) => {
//     setstage(e.target.value);
//   };

//   const onchannalchange = (e) => {
//     setchannal(e.target.value);
//   };

//   const oncommunicationwaychange = (e) => {
//     setcommunicationwat(e.target.value);
//   };

//   const onbudgetchange = (e) => {
//     setbudget(e.target.value);
//   };
//   //===================================================
//   //================================================sales filed

//   const ressales = useSelector((state) => state.AllSales.sales);

//   let salesData = [];

//   // if(ressales&&ressales.data)
//   // {
//   //   salesData=ressales.data
//   // }
//   // else
//   // {
//   //   salesData=[]
//   // }

//   //   if(ressales&&ressales.data)
//   // {
//   //   // Filter out sales with name "Default" or "Dev"
//   //   salesData = ressales.data.filter(
//   //     sale => sale.name !== "Default" &&sale.name !== "Default M"&&sale.name !== "Default T"&&sale.name !== "Default S"&&sale.name !== "Developer" && sale.name !== "Dev"
//   //   );
//   // }
//   // else
//   // {
//   //   salesData=[]
//   // }

//   if (ressales?.data) {
//     salesData = ressales.data
//       .filter(
//         (sale) =>
//           ![
//             'Default',
//             'Default M',
//             'Default T',
//             'Default S',
//             'Developer',
//             'Deveolper', // لتغطية الغلط الإملائي
//             'Dev',
//           ].includes(sale.name),
//       )
//       .sort((a, b) => {
//         if (a.name === 'No Sales') return -1;
//         if (b.name === 'No Sales') return 1;
//         return 0;
//       });
//   } else {
//     salesData = [];
//   }

//   //========================================================
//   //onsubmit event of form     update  client action

//   //convert imagecover from base64 to file
//   // function dataURLtoFile(dataurl, filename) {

//   //     var arr = dataurl.split(','),
//   //         mime = arr[0].match(/:(.*?);/)[1],
//   //         bstr = atob(arr[1]),
//   //         n = bstr.length,
//   //         u8arr = new Uint8Array(n);

//   //     while (n--) {
//   //         u8arr[n] = bstr.charCodeAt(n);
//   //     }

//   //     return new File([u8arr], filename, { type: mime });
//   //   }

//   //convert url to file
//   // const convertURLtoFile = async (url) => {
//   //   const response = await fetch(url, { mode: "cors" });
//   //   const data = await response.blob();
//   //   const ext = url.split(".").pop();
//   //   const filename = url.split("/").pop();
//   //   const metadata = { type: `image/${ext}` };
//   //   return new File([data], Math.random(), metadata);
//   // };

//   let user = '';
//   if (localStorage.getItem('user') != null) {
//     user = JSON.parse(localStorage.getItem('user'));
//   }

//   const onSubmit = async (e) => {
//     e.preventDefault();

//     if (name === '') {
//       Notify('error', 'Name is Required ', 'Error Message');
//       return;
//     }
//     // else if(email==="")
//     // {
//     //     Notify('error','Email is Required ','Error Message')
//     //     return
//     // }
//     //  else if(phone==="")
//     //   {
//     //       Notify('error','Phone is Required ','Error Message')
//     //       return
//     //   }
//     else if (value === '') {
//       Notify('error', 'Phone is Required ', 'Error Message');
//       return;
//     } else if (salesdata === '') {
//       Notify('error', 'Sales is Required ', 'Error Message');
//       return;
//     }
//     // if(stage===""||stage==="Choose Stage")
//     // {
//     //    Notify('error','Stage is Required ','Error Message')
//     //     return
//     // }
//     else {
//       // let imagecover;

//       // if(images[0].length<=1000)
//       // {
//       //   //url
//       //   convertURLtoFile(images[0]).then(val=> imagecover=val)
//       // }
//       // else
//       // {
//       //   imagecover=dataURLtoFile(images[0],Math.random()+".png")

//       // }
//       // let imagesitem=[]

//       //        Array.from(Array(Object.keys(images).length).keys()).map((item,index)=>{
//       //         if(images[index].length<=1000)
//       //         {
//       //           //url
//       //           convertURLtoFile(images[index]).then(val=> imagesitem.push(val))

//       //         }
//       //         else
//       //         {
//       //         imagesitem.push( dataURLtoFile(images[index],Math.random()+".png"))

//       //         }
//       //       })

//       // const formdata=new FormData();
//       // formdata.append("name",name);
//       // formdata.append("email",email);
//       // formdata.append("phone",phone);
//       // formdata.append("project",project);
//       // formdata.append("sales",salesdata);
//       // formdata.append("notes",note);
//       // formdata.append("locationurl",location);
//       // setTimeout(() => {
//       //   formdata.append("imageCover",imagecover);
//       //   imagesitem.map((img)=>formdata.append("images",img))
//       // }, 1000)
//       // formdata.append("stage",stage);

//       // setTimeout(async() => {
//       //   setloading(true)

//       //   await dispatch(UpdateClientAction(id,formdata))
//       //   setloading(false)
//       // }, 1000)

//       setloading(true);
//       setSubmitLoading(true);
//       await dispatch(
//         UpdateClientAction(id, {
//           name,
//           email,
//           // phone,
//           phone: '+' + value,
//           project,
//           sales: salesdata,
//           notes: note,
//           // date:Date.now(),
//           // stage:stage,
//           chanel: Channal,
//           communicationway: Communicationway,
//           leedtype: Leedtype,
//           budget: budget,
//           // countryname:selectedcountry,
//           dayonly: dateonly,
//           last_stage_date_updated: dateonly,
//           lastdateassign: dateonly,
//           lastcommentdate: '-',
//           updatedby: user._id,
//           whatsappnumber: whatsappnumber,
//           phonenumber2: phonenumber2,
//           jobdescription: jobDescription,
//           campaign: campaignid,
//         }),
//       );
//       setloading(false);
//       setSubmitLoading(false);

//       // setTimeout(() => {

//       //     window.location.href='#/AllLeadsForAdmin'
//       //  }, 2000)
//     }
//   };

//   const res = useSelector((state) => state.Allusers.Get_users);

//   useEffect(() => {
//     if (loading === false) {
//       if (res && res.data) {
//         setName('');
//         setEmail('');
//         // setPhone('')
//         setValue('');
//         setNote('');
//         setwhatsappnumber('');
//         setphonenumber2('');
//         setJobDescription('');
//         Notify('success', 'User Updated Successfully', 'Success Message');
//         setloading(false);
//       } else {
//         Notify('error', 'Faild To Update User ', 'Error Message');
//         setloading(false);
//       }
//     }
//   }, [loading]);

//   /////////////////////////////////////////////

//   // تحديد المسار بناءً على الدور
//   const homeRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/AllLeadsForAdmin'
//       : userlogin?.data?.role === 'Marketer'
//         ? '/ALLLeadsForMarketer'
//         : '/'; // fallback

//   return (
//     <Container className="startpage">
//       <Row>
//         <Col sm={2}></Col>
//         <Col sm={10}>
//           <div>
//             <Link to={homeRoute} style={{ textDecoration: 'none', color: '#102dff' }}>
//               <span style={{ fontWeight: 'bold' }}>Home</span>
//             </Link>
//             <KeyboardDoubleArrowRightIcon />
//             <span style={{ color: '#666' }}>Update Lead</span>
//           </div>

//           {/* Body */}
//           <div className="d-flex flex-wrap justify-content-center">
//             <Row
//               style={{
//                 width: '100%',
//                 marginTop: '50px',
//                 borderRadius: '10px',
//                 backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//                 color: mode === 'dark' ? '#ffffff' : '#000000',
//               }}
//             >
//               {/* First Row - Name and Email */}
//               <Row className="mb-3">
//                 <Col sm={6}>
//                   <label htmlFor="name">Name</label>
//                   <input
//                     onChange={onnamechange}
//                     value={name}
//                     className="inputsaddclient w-100"
//                     type="text"
//                     id="name"
//                     name="firstname"
//                     placeholder="Your name.."
//                   />
//                 </Col>
//                 <Col sm={6}>
//                   <label htmlFor="email">E-mail</label>
//                   <input
//                     onChange={onemailchange}
//                     value={email}
//                     className="inputsaddclient w-100"
//                     type="email"
//                     id="email"
//                     name="email"
//                     placeholder="Your Email.."
//                   />
//                 </Col>
//               </Row>

//               {/* Second Row - Phone and Second Phone */}
//               <Row className="mb-3">
//                 <Col sm={6}>
//                   <label className="my-1" htmlFor="Phone">
//                     Phone
//                   </label>
//                   <div className="w-100 my-2">
//                     <PhoneInput
//                       id="phone"
//                       country={'ae'}
//                       value={value}
//                       onChange={handlePhoneChange}
//                       onBlur={handleBlur}
//                       specialLabel="Phone"
//                       preferredCountries={['ae', 'us', 'gb']}
//                       inputClass="Phoneinput"
//                       dropdownClass="custom-dropdown"
//                     />
//                     {error && <p style={{ color: 'black' }}>{error}</p>}
//                   </div>
//                 </Col>
//                 <Col sm={6}>
//                   <label className="my-1" htmlFor="Phone2">
//                     Second Phone Number
//                   </label>
//                   <div className="w-100 my-2">
//                     <PhoneInput
//                       id="phone2"
//                       country={'ae'}
//                       value={phonenumber2}
//                       onChange={handlePhone2Change}
//                       onBlur={handleBlurphonenumber2}
//                       specialLabel="Phone 2"
//                       preferredCountries={['ae', 'us', 'gb']}
//                       inputClass="Phoneinput"
//                       dropdownClass="custom-dropdown"
//                     />
//                     {Errorphonenumber2 && <p style={{ color: '#0F7687' }}>{Errorphonenumber2}</p>}
//                   </div>
//                 </Col>
//               </Row>

//               {/* Third Row - WhatsApp and Project */}
//               <Row className="mb-3">
//                 <Col sm={6}>
//                   <label className="my-1" htmlFor="whatsapp">
//                     Whatsapp Number
//                   </label>
//                   <div className="w-100 my-2">
//                     <PhoneInput
//                       id="whatsapp"
//                       country={'ae'}
//                       value={whatsappnumber}
//                       onChange={handlewhatsappnumberChange}
//                       onBlur={handleBlurwhatsappnumber}
//                       specialLabel="Whatsapp Number"
//                       preferredCountries={['ae', 'us', 'gb']}
//                       inputClass="Phoneinput"
//                       dropdownClass="custom-dropdown"
//                     />
//                     {whatsappnumbererror && (
//                       <p style={{ color: '#0F7687' }}>{whatsappnumbererror}</p>
//                     )}
//                   </div>
//                 </Col>
//                 <Col sm={6}>
//                   <FormControl fullWidth style={{ marginTop: '7px' }}>
//                     <InputLabel id="select-label-project">Choose project</InputLabel>
//                     <Select
//                       labelId="select-label-project"
//                       id="select1"
//                       value={project}
//                       onChange={onprojectchange}
//                       label="Choose project"
//                     >
//                       {get_all_Projects_data &&
//                         get_all_Projects_data.map((project) => (
//                           <MenuItem key={project._id} value={project._id}>
//                             {project.name}
//                           </MenuItem>
//                         ))}
//                     </Select>
//                   </FormControl>
//                 </Col>
//               </Row>

//               {/* Fourth Row - Sales and Stage */}
//               <Row className="mb-3">
//                 <Col sm={6}>
//                   <FormControl fullWidth style={{ marginTop: '18px' }}>
//                     <InputLabel id="select-label-sales">Choose Sales</InputLabel>
//                     <Select
//                       labelId="select-label-sales"
//                       id="select2"
//                       value={salesdata}
//                       onChange={onsaleschange}
//                       label="Choose sales"
//                     >
//                       {salesData &&
//                         salesData.map((item) => {
//                           const isMe = item?.userlog?.email === userlogin?.data?.email;
//                           return (
//                             <MenuItem key={item._id} value={item._id}>
//                               <Box display="flex" flexDirection="column">
//                                 <Typography variant="subtitle1" fontWeight="bold">
//                                   {item.name} {isMe ? '(ME)' : ''}
//                                 </Typography>
//                                 <Typography variant="body2" color="text.secondary">
//                                   {item?.userlog?.role || 'No Role'}
//                                 </Typography>
//                               </Box>
//                             </MenuItem>
//                           );
//                         })}
//                     </Select>
//                   </FormControl>
//                 </Col>
//                 {/* <Col sm={6}> */}
//                 {/* <FormControl fullWidth style={{ marginTop: '18px' }}>
//                 <InputLabel id="select-label-stage">Choose Stage</InputLabel>
//                 <Select
//                   labelId="select-label-stage"
//                   id="select2"
//                   value={stage}
//                   onChange={onstagechange}
//                   label="Choose Stage"
//                 >
//                   {res_getallstages_array && res_getallstages_array.map((item) => (
//                     <MenuItem key={item._id} value={item._id}>{item.name}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl> */}
//                 {/* </Col> */}
//                 <Col sm={6}>
//                   <FormControl fullWidth className="my-3">
//                     <InputLabel id="demo-simple-select-label-campaignid">
//                       Choose Campaign id
//                     </InputLabel>
//                     <Select
//                       labelId="demo-simple-select-label-campaignid"
//                       id="demo-simple-select-campainid"
//                       value={campaignid}
//                       label="choose Campaign Id"
//                       onChange={oncampaignidchange}
//                     >
//                       {res_get_campaign_data_array &&
//                         res_get_campaign_data_array.map((item) => (
//                           <MenuItem value={item._id}>{item.CampainName}</MenuItem>
//                         ))}
//                     </Select>
//                   </FormControl>
//                 </Col>
//               </Row>

//               {/* Fifth Row - Channel and Communication Way */}
//               <Row className="mb-3">
//                 <Col sm={6}>
//                   <FormControl fullWidth>
//                     <InputLabel id="demo-simple-select-label-channal">Choose Channal</InputLabel>
//                     <Select
//                       labelId="demo-simple-select-label-channal"
//                       id="demo-simple-select-channal"
//                       value={Channal}
//                       label="choose Channal"
//                       onChange={onchannalchange}
//                     >
//                       {res_getallchannal_array &&
//                         res_getallchannal_array.map((item) => (
//                           <MenuItem value={item._id}>{item.name}</MenuItem>
//                         ))}
//                     </Select>
//                   </FormControl>
//                 </Col>
//                 <Col sm={6}>
//                   {/* <FormControl fullWidth>
//                 <InputLabel id="demo-simple-select-label-communication-way">Choose Communication Way</InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label-communication-way"
//                   id="demo-simple-select-communication-way"
//                   value={Communicationway}
//                   label="choose Communication Way"
//                   onChange={oncommunicationwaychange}
//                 >
//                   {res_getallcommunicationway_array && res_getallcommunicationway_array.map((item, index) => (
//                     <MenuItem key={index} value={item._id}>{item.name}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl> */}

//                   <FormControl fullWidth>
//                     <InputLabel id="demo-simple-select-label-communication-way">
//                       Choose Communication Way
//                     </InputLabel>
//                     <Select
//                       labelId="demo-simple-select-label-communication-way"
//                       id="demo-simple-select-communication-way"
//                       value={Communicationway}
//                       label="Choose Communication Way"
//                       onChange={oncommunicationwaychange}
//                     >
//                       {res_getallcommunicationway_array &&
//                         [...res_getallcommunicationway_array]
//                           // ✅ نخلي "No Communication Way" أول عنصر
//                           .sort((a, b) =>
//                             a.name === 'No Communication Way'
//                               ? -1
//                               : b.name === 'No Communication Way'
//                                 ? 1
//                                 : 0,
//                           )
//                           .map((item, index) => (
//                             <MenuItem key={index} value={item._id}>
//                               {item.name}
//                             </MenuItem>
//                           ))}
//                     </Select>
//                   </FormControl>
//                 </Col>
//               </Row>

//               {/* Sixth Row - Campaign and Job Description */}
//               <Row className="mb-3">
//                 {/* <Col sm={6}>
//               <FormControl fullWidth className='my-3'>
//                 <InputLabel id="demo-simple-select-label-campaignid">Choose Campaign id</InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label-campaignid"
//                   id="demo-simple-select-campainid"
//                   value={campaignid}
//                   label="choose Campaign Id"
//                   onChange={oncampaignidchange}
//                 >
//                   {res_get_campaign_data_array && res_get_campaign_data_array.map((item) => (
//                     <MenuItem value={item._id}>{item.CampainName}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Col> */}
//                 <Col sm={12}>
//                   <label htmlFor="jobDescription">Job Description</label>
//                   <input
//                     onChange={onjobdescriptionchange}
//                     value={jobDescription}
//                     className="inputsaddclient w-100"
//                     type="text"
//                     id="jobDescription"
//                     placeholder="Job Description"
//                   />
//                 </Col>
//               </Row>

//               {/* Seventh Row - Budget and Note */}
//               <Row className="mb-3">
//                 <Col sm={6}>
//                   <label htmlFor="budget">Budget</label>
//                   <input
//                     onChange={onbudgetchange}
//                     value={budget}
//                     className="inputsaddclient w-100"
//                     type="Number"
//                     id="Budget"
//                     name="budget"
//                     placeholder="Your Budget.."
//                   />
//                 </Col>
//                 <Col sm={6}>
//                   <label htmlFor="note">Note</label>
//                   <input
//                     onChange={onnotechange}
//                     value={note}
//                     className="inputsaddclient w-100"
//                     type="text"
//                     id="note"
//                     name="firstname"
//                     placeholder="Your Note.."
//                   />
//                 </Col>
//               </Row>

//               {/* Eighth Row - Lead Type */}
//               <Row className="mb-3">
//                 <Col sm={6}>
//                   <div className="my-3">
//                     <label>Leed Type</label>
//                     <Switch
//                       checked={checked}
//                       onChange={handleChange}
//                       inputProps={{ 'aria-label': 'controlled' }}
//                     />
//                     <label>{Leedtype}</label>
//                   </div>
//                 </Col>

//                 <Col sm={6}>
//                   {/* Submit Button */}
//                   <div
//                     onClick={!submitLoading ? onSubmit : null}
//                     className="addnewclient"
//                     style={{
//                       background: '#102dff',
//                       pointerEvents: submitLoading ? 'none' : 'auto',
//                       opacity: submitLoading ? 0.6 : 1,
//                       cursor: submitLoading ? 'not-allowed' : 'pointer',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       gap: '6px',
//                       height: '40px',
//                       width: '100%',
//                     }}
//                     type="submit"
//                   >
//                     {submitLoading ? (
//                       <CircularProgress size={20} style={{ color: 'white' }} />
//                     ) : (
//                       <>
//                         <EditIcon /> Update Lead
//                       </>
//                     )}
//                   </div>
//                 </Col>
//               </Row>
//             </Row>

//             <hr />

//             {/* Submit Button */}
//             {/* <div
//           onClick={!submitLoading ? onSubmit : null}
//           className='addnewclient'
//           style={{
//             background: '#0F7687',
//             pointerEvents: submitLoading ? 'none' : 'auto',
//             opacity: submitLoading ? 0.6 : 1,
//             cursor: submitLoading ? 'not-allowed' : 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '6px',
//             height: '40px'
//           }}
//           type="submit"
//         >
//           {submitLoading ? (
//             <CircularProgress size={20} style={{ color: 'white' }} />
//           ) : (
//             <>
//               <EditIcon /> Update Lead
//             </>
//           )}
//         </div> */}
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };


















// 20-5-2026
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useParams } from 'react-router-dom';
// import { GetOneClientAction, UpdateClientAction } from '../Redux/Actions/UsersAction';
// import { Notify } from '../Utility/Notify';
// import EditIcon from '@mui/icons-material/Edit';
// import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
// import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
// import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import { parsePhoneNumberFromString } from 'libphonenumber-js';
// import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
// import { useTheme } from '@mui/material/styles';
// import CircularProgress from '@mui/material/CircularProgress';
// import Switch from '@mui/material/Switch';
// import { useSidebarWidth } from '../Utility/useSidebarWidth';

// /* ─────────────────────────────────────────────
//    DESIGN TOKENS
// ───────────────────────────────────────────── */
// const T = {
//   navy:        '#0B1437',
//   navyLight:   '#0F1D4A',
//   navyBorder:  '#0D47A1',
//   accent:      '#0D47A1',
//   accentBg:    'rgba(26,60,219,0.08)',
//   white:       '#FFFFFF',
//   offWhite:    '#f0f2f5',
//   surface:     '#FFFFFF',
//   border:      '#DDE3F0',
//   borderLight: '#EEF1FA',
//   text:        '#0B1437',
//   textMuted:   '#6B7694',
//   textLight:   '#9BA5C9',
//   gold:        '#C8A96E',
//   danger:      '#E24B4A',
//   success:     '#1D9E75',
//   warning:     '#BA7517',
//   labelSize:   '11px',
//   sectionFont: "'DM Sans', 'Georgia', sans-serif",
//   bodyFont:    "'DM Sans', sans-serif",
//   darkBg:      '#0f1117',
//   darkSurface: '#1a1d2e',
//   darkSurface2:'#161929',
//   darkBorder:  '#2a2f45',
//   darkText:    '#e5e7eb',
//   darkMuted:   '#6b7280',
// };

// /* ── Google Fonts ── */
// if (typeof document !== 'undefined' && !document.getElementById('azure-fonts')) {
//   const link = document.createElement('link');
//   link.id   = 'azure-fonts';
//   link.rel  = 'stylesheet';
//   link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=DM+Sans:wght@300;400;500;600&display=swap';
//   document.head.appendChild(link);
// }

// /* ─────────────────────────
//    Mini Components
// ───────────────────────── */
// const SectionTag = ({ number, label }) => (
//   <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'20px' }}>
//     <div style={{ width:'28px', height:'2px', background: T.accent }} />
//     <span style={{
//       fontFamily: T.bodyFont, fontSize: T.labelSize, fontWeight:'700',
//       letterSpacing:'2px', color: T.accent, textTransform:'uppercase',
//     }}>
//       Section {String(number).padStart(2,'0')} / {label}
//     </span>
//   </div>
// );

// const FieldLabel = ({ children, isDark }) => (
//   <label style={{
//     display:'block', marginBottom:'6px', fontFamily: T.bodyFont,
//     fontSize: T.labelSize, fontWeight:'700', letterSpacing:'1.5px',
//     textTransform:'uppercase', color: isDark ? T.darkMuted : T.textMuted,
//   }}>
//     {children}
//   </label>
// );

// const getInputStyle = (isDark) => ({
//   width:'100%', padding:'10px 14px', borderRadius:'10px',
//   border:`1.5px solid ${isDark ? T.darkBorder : T.border}`,
//   background: isDark ? T.darkSurface2 : '#FAFBFF',
//   color: isDark ? T.darkText : T.text,
//   fontSize:'13px', fontFamily: T.bodyFont,
//   outline:'none', transition:'border-color .2s, box-shadow .2s', boxSizing:'border-box',
//   letterSpacing:'0.01em',
// });

// const SectionCard = ({ children, isDark, style }) => (
//   <div style={{
//     background: isDark ? T.darkSurface : T.surface,
//     border:`1px solid ${isDark ? T.darkBorder : T.border}`,
//     borderRadius:'12px', padding:'28px', marginBottom:'20px', ...style,
//   }}>
//     {children}
//   </div>
// );

// /* ─────────────────────────────────────────────
//    LuxuryAutocomplete
// ───────────────────────────────────────────── */
// const getProjectIcon = (name = '') => {
//   const n = name.toLowerCase();
//   if (n.includes('villa') || n.includes('residence')) return '🏡';
//   if (n.includes('beach') || n.includes('leisure') || n.includes('oasis')) return '🏖';
//   if (n.includes('commercial') || n.includes('hub') || n.includes('general')) return '🏗';
//   if (n.includes('logistic') || n.includes('industrial')) return '🏭';
//   if (n.includes('urban') || n.includes('city')) return '🏙';
//   if (n.includes('luxury') || n.includes('premium')) return '💎';
//   return '🏢';
// };

// const getProjectSubtitle = (name = '') => {
//   const n = name.toLowerCase();
//   if (n.includes('villa')) return 'LUXURY LIVING';
//   if (n.includes('beach') || n.includes('oasis')) return 'LEISURE ESTATES';
//   if (n.includes('commercial') || n.includes('hub')) return 'COMMERCIAL HUB';
//   if (n.includes('logistic')) return 'INDUSTRIAL';
//   if (n.includes('urban')) return 'URBAN PORTFOLIO';
//   if (n.includes('residence') || n.includes('tower')) return 'RESIDENTIAL';
//   return 'REAL ESTATE';
// };

// const LuxuryAutocomplete = ({
//   options = [],
//   value,
//   onChange,
//   placeholder,
//   loading,
//   isDark,
//   getLabel,
//   getSubtitle,
//   getIcon,
//   disabled,
// }) => {
//   const [open,   setOpen]   = useState(false);
//   const [search, setSearch] = useState('');
//   const ref = React.useRef(null);

//   const labelFn    = getLabel    || (o => o?.name || '');
//   const subtitleFn = getSubtitle || (o => getProjectSubtitle(o?.name || ''));
//   const iconFn     = getIcon     || (o => getProjectIcon(o?.name || ''));

//   const filtered = options.filter(o =>
//     labelFn(o).toLowerCase().includes(search.toLowerCase())
//   );

//   useEffect(() => {
//     const handler = (e) => {
//       if (ref.current && !ref.current.contains(e.target)) setOpen(false);
//     };
//     document.addEventListener('mousedown', handler);
//     return () => document.removeEventListener('mousedown', handler);
//   }, []);

//   return (
//     <div ref={ref} style={{ position:'relative', width:'100%' }}>

//       {/* Trigger */}
//       <div
//         onClick={() => !disabled && setOpen(o => !o)}
//         style={{
//           display:'flex', alignItems:'center', gap:'10px',
//           padding:'0 14px', height:'42px', borderRadius:'10px',
//           border:`1.5px solid ${open ? T.accent : isDark ? T.darkBorder : T.border}`,
//           background: isDark ? T.darkSurface2 : '#FAFBFF',
//           cursor: disabled ? 'not-allowed' : 'pointer',
//           transition:'border-color .2s, box-shadow .2s',
//           boxShadow: open ? `0 0 0 3px rgba(13,71,161,0.08)` : 'none',
//           opacity: disabled ? 0.6 : 1,
//           userSelect:'none',
//         }}
//       >
//         {value ? (
//           <>
//             <div style={{
//               width:'28px', height:'28px', borderRadius:'7px', flexShrink:0,
//               background: isDark ? T.darkBorder : '#EEF1FA',
//               display:'flex', alignItems:'center', justifyContent:'center', fontSize:'14px',
//             }}>
//               {iconFn(value)}
//             </div>
//             <div style={{ flex:1, minWidth:0 }}>
//               <div style={{ fontSize:'13px', fontWeight:'600', color: isDark?T.darkText:T.text, fontFamily:T.bodyFont, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
//                 {labelFn(value)}
//               </div>
//               <div style={{ fontSize:'10px', letterSpacing:'1.5px', color:T.accent, fontWeight:'700', fontFamily:T.bodyFont, textTransform:'uppercase' }}>
//                 {subtitleFn(value)}
//               </div>
//             </div>
//           </>
//         ) : (
//           <span style={{ fontSize:'13px', color: isDark?T.darkMuted:T.textLight, fontFamily:T.bodyFont }}>
//             {placeholder || 'Select...'}
//           </span>
//         )}
//         <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
//           style={{ flexShrink:0, marginLeft:'auto', transition:'transform .2s', transform: open?'rotate(180deg)':'none' }}>
//           <path d="M2 4l4 4 4-4" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//         </svg>
//       </div>

//       {/* Dropdown */}
//       {open && (
//         <div style={{
//           position:'absolute', top:'calc(100% + 6px)', left:0, right:0, zIndex:9999,
//           background: isDark ? T.darkSurface : '#FFFFFF',
//           border:`1.5px solid ${isDark?T.darkBorder:'#DDE3F0'}`,
//           borderRadius:'12px',
//           boxShadow:'0 12px 40px rgba(11,20,55,0.15)',
//           overflow:'hidden', maxHeight:'320px',
//           display:'flex', flexDirection:'column',
//         }}>

//           {/* Search */}
//           <div style={{ padding:'10px 12px', borderBottom:`1px solid ${isDark?T.darkBorder:'#EEF1FA'}` }}>
//             <div style={{ display:'flex', alignItems:'center', gap:'8px', padding:'8px 12px', borderRadius:'8px', background: isDark?T.darkSurface2:'#F4F6FB' }}>
//               <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                 <circle cx="6" cy="6" r="4.5" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.3"/>
//                 <path d="M9.5 9.5l2 2" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.3" strokeLinecap="round"/>
//               </svg>
//               <input
//                 autoFocus
//                 value={search}
//                 onChange={e => setSearch(e.target.value)}
//                 placeholder={`Search ${placeholder||'options'}...`}
//                 style={{ border:'none', outline:'none', background:'transparent', fontSize:'13px', fontFamily:T.bodyFont, flex:1, color: isDark?T.darkText:T.text }}
//               />
//               {search && (
//                 <span onClick={() => setSearch('')} style={{ cursor:'pointer', color:isDark?T.darkMuted:T.textLight, fontSize:'16px', lineHeight:1 }}>×</span>
//               )}
//             </div>
//           </div>

//           {/* Options */}
//           <div style={{ overflowY:'auto', flex:1 }}>
//             {loading ? (
//               <div style={{ padding:'20px', textAlign:'center', fontSize:'13px', color:isDark?T.darkMuted:T.textMuted, fontFamily:T.bodyFont }}>Loading...</div>
//             ) : filtered.length === 0 ? (
//               <div style={{ padding:'20px', textAlign:'center', fontSize:'13px', color:isDark?T.darkMuted:T.textMuted, fontFamily:T.bodyFont }}>No results found</div>
//             ) : filtered.map((opt, i) => {
//               const isSelected = value && labelFn(value) === labelFn(opt);
//               return (
//                 <div
//                   key={opt._id || i}
//                   onClick={() => { onChange(opt); setOpen(false); setSearch(''); }}
//                   style={{
//                     display:'flex', alignItems:'center', gap:'12px',
//                     padding:'11px 14px', cursor:'pointer',
//                     background: isSelected ? (isDark?'rgba(13,71,161,0.15)':'#F0F4FF') : 'transparent',
//                     borderLeft: isSelected ? `3px solid ${T.accent}` : '3px solid transparent',
//                     transition:'background .12s',
//                   }}
//                   onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = isDark?'rgba(255,255,255,0.04)':'#F8F9FD'; }}
//                   onMouseLeave={e => { e.currentTarget.style.background = isSelected?(isDark?'rgba(13,71,161,0.15)':'#F0F4FF'):'transparent'; }}
//                 >
//                   <div style={{
//                     width:'32px', height:'32px', borderRadius:'8px', flexShrink:0,
//                     background: isSelected?(isDark?'rgba(13,71,161,0.25)':'#DDEAFF'):(isDark?T.darkBorder:'#EEF1FA'),
//                     display:'flex', alignItems:'center', justifyContent:'center', fontSize:'15px',
//                   }}>
//                     {iconFn(opt)}
//                   </div>
//                   <div style={{ flex:1, minWidth:0 }}>
//                     <div style={{ fontSize:'13px', fontWeight:isSelected?'600':'500', color:isSelected?T.accent:(isDark?T.darkText:T.text), fontFamily:T.bodyFont, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
//                       {labelFn(opt)}
//                     </div>
//                     <div style={{ fontSize:'10px', letterSpacing:'1.2px', fontWeight:'700', color:isSelected?T.accent:(isDark?T.darkMuted:T.textLight), fontFamily:T.bodyFont, textTransform:'uppercase', marginTop:'1px' }}>
//                       {subtitleFn(opt)}
//                     </div>
//                   </div>
//                   {isSelected && (
//                     <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink:0 }}>
//                       <circle cx="8" cy="8" r="7" stroke={T.accent} strokeWidth="1.5"/>
//                       <path d="M5 8l2 2 4-4" stroke={T.accent} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//                     </svg>
//                   )}
//                 </div>
//               );
//             })}
//           </div>

//           {/* Footer */}
//           <div style={{ padding:'10px 14px', textAlign:'center', borderTop:`1px solid ${isDark?T.darkBorder:'#EEF1FA'}` }}>
//             <span style={{ fontSize:'11px', letterSpacing:'1.5px', fontWeight:'700', color:T.accent, textTransform:'uppercase', fontFamily:T.bodyFont, cursor:'pointer' }}>
//               VIEW ALL ENTITIES
//             </span>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────
//    MAIN COMPONENT
// ───────────────────────────────────────────── */
// export const UpdateClient = () => {
//   const theme        = useTheme();
//   const isDark       = theme.palette.mode === 'dark';
//   const { id }       = useParams();
//   const dispatch     = useDispatch();
//   const sidebarWidth = useSidebarWidth();

//   const [userlogin, setuserlogin] = useState(null);
//   useEffect(() => {
//     try { const u = localStorage.getItem('user'); if (u) setuserlogin(JSON.parse(u)); } catch { setuserlogin(null); }
//   }, []);

//   const [submitLoading, setSubmitLoading] = useState(false);

//   /* ── Date ── */
//   const [dateonly, setDateonly] = useState('');
//   useEffect(() => {
//     const d = new Date();
//     setDateonly(`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`);
//   }, []);

//   /* ── Fields ── */
//   const [name,             setName]             = useState('');
//   const [email,            setEmail]            = useState('');
//   const [note,             setNote]             = useState('');
//   const [project,          setproject]          = useState('');
//   const [salesdata,        setsalesdata]        = useState('');
//   const [loading,          setloading]          = useState(true);
//   const [stage,            setstage]            = useState('');
//   const [Channal,          setchannal]          = useState('');
//   const [Communicationway, setcommunicationwat] = useState('');
//   const [budget,           setbudget]           = useState(0);
//   const [checked,          setChecked]          = useState(true);
//   const [Leedtype,         setLeedtype]         = useState('Fresh');
//   const [campaignid,       setcampaignid]       = useState('');
//   const [jobDescription,   setJobDescription]   = useState('');

//   /* ── Phone ── */
//   const [value,               setValue]              = useState('');
//   const [phonenumber2,        setphonenumber2]        = useState('');
//   const [whatsappnumber,      setwhatsappnumber]      = useState('');
//   const [error,               setError]              = useState('');
//   const [Errorphonenumber2,   setErrorphonenumber2]  = useState('');
//   const [whatsappnumbererror, setwhatsappnumbererror] = useState('');
//   const [countryName,         setCountryName]        = useState('');

//   const handlePhoneChange = (newValue, countryData) => {
//     setValue(newValue); setError('');
//     if (countryData) setCountryName(countryData.name);
//   };
//   const handleBlur = () => {
//     const pn = parsePhoneNumberFromString(`+${value}`);
//     setError(pn && pn.isValid() ? '' : 'Please enter a valid phone number');
//   };
//   const handlePhone2Change         = (v) => { setphonenumber2(v);   setErrorphonenumber2('');   };
//   const handlewhatsappnumberChange = (v) => { setwhatsappnumber(v); setwhatsappnumbererror(''); };
//   const handleBlurphonenumber2     = () => { const p = parsePhoneNumberFromString(`+${phonenumber2}`);   setErrorphonenumber2(p&&p.isValid()?'':'Please enter a valid phone number 2'); };
//   const handleBlurwhatsappnumber   = () => { const p = parsePhoneNumberFromString(`+${whatsappnumber}`); setwhatsappnumbererror(p&&p.isValid()?'':'Please enter a valid whatsapp number'); };

//   useEffect(() => { setLeedtype(checked ? 'Fresh' : 'Cold'); }, [checked]);

//   /* ── Load data ── */
//   useEffect(() => {
//     const run = async () => {
//       await dispatch(GetOneClientAction(id));
//       await dispatch(GetallProjectsdata());
//       await dispatch(Get_All_Sales_Action());
//       await dispatch(GetAll_stage_Data());
//       await dispatch(GetAllchannalData());
//       await dispatch(GetCommunicationwayData());
//       await dispatch(GetAllCampainData());
//     };
//     run();
//   }, []);

//   const resone_user_data          = useSelector(s => s.Allusers.Get_users);
//   const resGetProjectsData        = useSelector(s => s.AllProjects.Projects);
//   const resgetallstages           = useSelector(s => s.Allstages.stage);
//   const resgetallchannal          = useSelector(s => s.AllChannalRoot.channal);
//   const resgetallcommunicationway = useSelector(s => s.AllCommunicationway.communicationway);
//   const resgetcampaindata         = useSelector(s => s.AllCampaign.campaign);
//   const ressales                  = useSelector(s => s.AllSales.sales);
//   const res                       = useSelector(s => s.Allusers.Get_users);

//   const res_getallchannal_array          = Array.isArray(resgetallchannal?.data)          ? resgetallchannal.data          : [];
//   const res_getallcommunicationway_array = Array.isArray(resgetallcommunicationway?.data) ? resgetallcommunicationway.data : [];
//   const res_get_campaign_data_array      = Array.isArray(resgetcampaindata?.data)         ? resgetcampaindata.data         : [];
//   const get_all_Projects_data            = resGetProjectsData?.data || [];

//   const one_user_data = resone_user_data?.data || {};

//   let salesData = ressales?.data
//     ? ressales.data
//         .filter(s => !['Default','Default M','Default T','Default S','Developer','Deveolper','Dev'].includes(s.name))
//         .sort((a,b) => a.name==='No Sales'?-1:b.name==='No Sales'?1:0)
//     : [];

//   /* ── Populate fields from fetched lead ── */
//   useEffect(() => {
//     if (one_user_data && Object.keys(one_user_data).length > 0) {
//       setName(one_user_data?.name || '');
//       setEmail(one_user_data?.email || '');
//       setValue(one_user_data?.phone?.toString() || '');
//       setphonenumber2(one_user_data?.phonenumber2?.toString() || '');
//       setwhatsappnumber(one_user_data?.whatsappnumber?.toString() || '');
//       setJobDescription(one_user_data?.jobdescription || '');
//       setNote(one_user_data?.notes || '');
//       setproject(one_user_data?.project?._id || '');
//       setsalesdata(one_user_data?.sales?._id || '');
//       setstage(one_user_data?.stage?._id || '');
//       setcommunicationwat(one_user_data?.communicationway?._id || '');
//       setcampaignid(one_user_data?.campaign?._id || '');
//       setchannal(one_user_data?.chanel?._id || '');
//       setbudget(one_user_data?.budget || 0);
//       setCountryName(one_user_data?.countryname || '');
//       setChecked(one_user_data?.leedtype === 'Fresh');
//     }
//   }, [one_user_data]);

//   /* ── Submit ── */
//   const user = (() => { try { return JSON.parse(localStorage.getItem('user')); } catch { return null; } })();

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     if (!name)      { Notify('error','Name is Required','Error Message'); return; }
//     if (!value)     { Notify('error','Phone is Required','Error Message'); return; }
//     if (!salesdata) { Notify('error','Sales is Required','Error Message'); return; }

//     setloading(true);
//     setSubmitLoading(true);
//     await dispatch(UpdateClientAction(id, {
//       name, email, phone:'+'+value, project, sales:salesdata, notes:note,
//       chanel:Channal, communicationway:Communicationway, leedtype:Leedtype,
//       budget, dayonly:dateonly, last_stage_date_updated:dateonly,
//       lastdateassign:dateonly, lastcommentdate:'-', updatedby:user?._id,
//       whatsappnumber, phonenumber2, jobdescription:jobDescription, campaign:campaignid,
//     }));
//     setloading(false);
//     setSubmitLoading(false);
//   };

//   useEffect(() => {
//     if (loading === false) {
//       if (res && res.data) {
//         setName(''); setEmail(''); setValue(''); setNote('');
//         setwhatsappnumber(''); setphonenumber2(''); setJobDescription('');
//         Notify('success','User Updated Successfully','Success Message');
//       } else {
//         Notify('error','Failed To Update User','Error Message');
//       }
//       setloading(false);
//     }
//   }, [loading]);

//   /* ── Route helper ── */
//   const getHomeRoute = () => {
//     switch(userlogin?.data?.role) {
//       case 'Admin':    return '/AllLeadsForAdmin';
//       case 'Marketer': return '/ALLLeadsForMarketer';
//       default:         return '/';
//     }
//   };

//   /* ── Shared styles ── */
//   const inputStyle = getInputStyle(isDark);

//   const phoneButtonStyle = {
//     background: isDark ? T.darkSurface2 : '#F4F6FB',
//     border: `1.5px solid ${isDark ? T.darkBorder : T.border}`,
//     borderRadius:'10px 0 0 10px', borderRight:'none', padding:'0 10px',
//   };
//   const phoneDropdownStyle = {
//     background: isDark ? T.darkSurface : '#FFFFFF',
//     color: isDark ? T.darkText : T.text,
//     borderRadius:'10px',
//     border:`1.5px solid ${isDark ? T.darkBorder : T.border}`,
//     boxShadow:'0 8px 32px rgba(11,20,55,0.12)', marginTop:'4px',
//   };
//   const phoneInputStyle = {
//     ...inputStyle, height:'42px', paddingLeft:'52px',
//     borderRadius:'0 10px 10px 0', width:'100%',
//   };

//   /* ── Channel helpers ── */
//   const getChannelIcon = (o) => {
//     const n = (o?.name||'').toLowerCase();
//     if (n.includes('social')||n.includes('instagram')||n.includes('facebook')) return '📱';
//     if (n.includes('email')) return '📧';
//     if (n.includes('referral')) return '🤝';
//     if (n.includes('web')||n.includes('site')) return '🌐';
//     if (n.includes('call')||n.includes('phone')) return '📞';
//     if (n.includes('whatsapp')) return '💬';
//     return '📡';
//   };
//   const getChannelSubtitle = (o) => {
//     const n = (o?.name||'').toLowerCase();
//     if (n.includes('social')) return 'DIGITAL MEDIA';
//     if (n.includes('referral')) return 'WORD OF MOUTH';
//     if (n.includes('web')) return 'ONLINE';
//     if (n.includes('email')) return 'EMAIL MARKETING';
//     return 'ACQUISITION CHANNEL';
//   };

//   const getCommunicationIcon = (o) => {
//     const n = (o?.name||'').toLowerCase();
//     if (n.includes('whatsapp')) return '💬';
//     if (n.includes('call')||n.includes('phone')) return '📞';
//     if (n.includes('email')) return '📧';
//     if (n.includes('meeting')||n.includes('person')) return '🤝';
//     if (n.includes('sms')) return '✉️';
//     return '📋';
//   };
//   const getCommunicationSubtitle = () => 'COMMUNICATION';

//   /* ─────────────────────────
//      RENDER
//   ───────────────────────── */
//   return (
//     <div style={{
//       position:'fixed', top:'50px', left:sidebarWidth, right:0, bottom:0,
//       transition:'left 0.25s cubic-bezier(0.4,0,0.2,1)',
//       display:'flex', flexDirection:'column', overflow:'hidden',
//       backgroundColor: isDark ? T.darkBg : T.offWhite,
//       fontFamily: T.bodyFont,
//     }}>

//       {/* ── Breadcrumb ── */}
//       <div style={{
//         padding:'14px 28px', flexShrink:0,
//         backgroundColor: isDark ? T.darkSurface : T.offWhite,
//         display:'flex', alignItems:'center', gap:'8px', fontSize:'13px',
//       }}>
//         <Link to={getHomeRoute()} style={{ textDecoration:'none', color: isDark?'#9ca3af':'#6b7280', fontWeight:'500' }}>
//           Home
//         </Link>
//         <span style={{ color: isDark?'#4b5563':'#d1d5db' }}>/</span>
//         <span style={{ color: isDark?'#e5e7eb':'#111827', fontWeight:'600' }}>Update Lead</span>
//       </div>

//       {/* ── Scrollable Body ── */}
//       <div style={{ flex:1, overflowY:'auto', overflowX:'hidden', display:'flex', flexDirection:'column' }}>
//         <div style={{ padding:'24px 28px', flex:1 }}>

//           {/* Page Heading */}
//           <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:'28px' }}>
//             <div>
//               <div style={{ fontSize:T.labelSize, fontWeight:'700', letterSpacing:'2px', textTransform:'uppercase', color:T.accent, marginBottom:'6px', fontFamily:T.bodyFont }}>
//                 LEADS / UPDATE
//               </div>
//               <h1 style={{ fontFamily:T.sectionFont, fontSize:'34px', fontWeight:'700', color:isDark?T.darkText:T.text, margin:'0 0 6px', letterSpacing:'-0.5px' }}>
//                 Update Lead
//               </h1>
//               <p style={{ margin:0, fontSize:'14px', color:isDark?T.darkMuted:T.textMuted, fontWeight:'300' }}>
//                 Modify and refine the lead profile within the system.
//               </p>
//             </div>
//             {/* Lead type badge */}
//             <div style={{
//               padding:'8px 18px', borderRadius:'20px',
//               background: checked ? 'rgba(29,158,117,0.1)' : 'rgba(107,114,128,0.1)',
//               border:`1.5px solid ${checked ? T.success : isDark?T.darkBorder:T.border}`,
//               display:'flex', alignItems:'center', gap:'8px',
//             }}>
//               <span style={{ width:'7px', height:'7px', borderRadius:'50%', background: checked?T.success:T.textMuted, display:'inline-block' }} />
//               <span style={{ fontSize:'12px', fontWeight:'600', color: checked?T.success:isDark?T.darkMuted:T.textMuted, fontFamily:T.bodyFont, letterSpacing:'0.5px' }}>
//                 {checked ? 'Fresh Lead' : 'Cold Lead'}
//               </span>
//             </div>
//           </div>

//           {/* ══ SECTION 01 / IDENTITY ══ */}
//           <SectionCard isDark={isDark}>
//             <SectionTag number={1} label="Identity" />
//             <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px' }}>

//               <div>
//                 <FieldLabel isDark={isDark}>Full Name *</FieldLabel>
//                 <input value={name} onChange={e=>setName(e.target.value)} style={inputStyle}
//                   type="text" placeholder="e.g. Alexander Hamilton"
//                   onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
//                   onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
//                 />
//               </div>

//               <div>
//                 <FieldLabel isDark={isDark}>Email Address (Optional)</FieldLabel>
//                 <input value={email} onChange={e=>setEmail(e.target.value)} style={inputStyle}
//                   type="email" placeholder="client@private-estate.com"
//                   onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
//                   onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
//                 />
//               </div>

//               {/* Primary Phone */}
//               <div>
//                 <FieldLabel isDark={isDark}>Primary Phone *</FieldLabel>
//                 <PhoneInput
//                   country={'ae'} value={value}
//                   onChange={handlePhoneChange} onBlur={handleBlur}
//                   preferredCountries={['ae','us','gb']}
//                   inputStyle={phoneInputStyle}
//                   buttonStyle={phoneButtonStyle}
//                   dropdownStyle={phoneDropdownStyle}
//                   containerStyle={{ width:'100%' }}
//                 />
//                 {error && <p style={{ marginTop:'6px', fontSize:'12px', color:T.danger, fontFamily:T.bodyFont }}>{error}</p>}
//               </div>

//               {/* Second Phone */}
//               <div>
//                 <FieldLabel isDark={isDark}>Second Phone (Optional)</FieldLabel>
//                 <PhoneInput
//                   country={'ae'} value={phonenumber2}
//                   onChange={handlePhone2Change} onBlur={handleBlurphonenumber2}
//                   preferredCountries={['ae','us','gb']}
//                   inputStyle={phoneInputStyle}
//                   buttonStyle={phoneButtonStyle}
//                   dropdownStyle={phoneDropdownStyle}
//                   containerStyle={{ width:'100%' }}
//                 />
//                 {Errorphonenumber2 && <p style={{ marginTop:'6px', fontSize:'12px', color:T.danger, fontFamily:T.bodyFont }}>{Errorphonenumber2}</p>}
//               </div>

//               {/* WhatsApp */}
//               <div>
//                 <FieldLabel isDark={isDark}>WhatsApp Number (Optional)</FieldLabel>
//                 <PhoneInput
//                   country={'ae'} value={whatsappnumber}
//                   onChange={handlewhatsappnumberChange} onBlur={handleBlurwhatsappnumber}
//                   preferredCountries={['ae','us','gb']}
//                   inputStyle={phoneInputStyle}
//                   buttonStyle={phoneButtonStyle}
//                   dropdownStyle={phoneDropdownStyle}
//                   containerStyle={{ width:'100%' }}
//                 />
//                 {whatsappnumbererror && <p style={{ marginTop:'6px', fontSize:'12px', color:T.danger, fontFamily:T.bodyFont }}>{whatsappnumbererror}</p>}
//               </div>

//             </div>
//           </SectionCard>

//           {/* ══ SECTION 02 + 03 ══ */}
//           <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px', marginBottom:'20px' }}>

//             {/* ── SECTION 02 / ACQUISITION ── */}
//             <div style={{ background:isDark?T.darkSurface:T.surface, border:`1px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'12px', padding:'28px' }}>
//               <SectionTag number={2} label="Acquisition" />
//               <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

//                 {/* Project */}
//                 <div>
//                   <FieldLabel isDark={isDark}>Project</FieldLabel>
//                   <LuxuryAutocomplete
//                     options={get_all_Projects_data}
//                     value={get_all_Projects_data.find(p => p._id === project) || null}
//                     onChange={v => setproject(v ? v._id : '')}
//                     placeholder="Select project"
//                     isDark={isDark}
//                   />
//                 </div>

//                 {/* Sales */}
//                 <div>
//                   <FieldLabel isDark={isDark}>Sales *</FieldLabel>
//                   <LuxuryAutocomplete
//                     options={salesData}
//                     value={salesData.find(s => s._id === salesdata) || null}
//                     onChange={v => setsalesdata(v ? v._id : '')}
//                     placeholder="Select sales"
//                     isDark={isDark}
//                     getIcon={() => '👤'}
//                     getSubtitle={o => {
//                       const isMe = o?.userlog?.email === userlogin?.data?.email;
//                       return isMe ? 'YOU — SALES AGENT' : (o?.teamleader?.name ? `TEAM: ${o.teamleader.name.toUpperCase()}` : 'SALES AGENT');
//                     }}
//                   />
//                 </div>

//                 {/* Campaign + Channel */}
//                 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
//                   <div>
//                     <FieldLabel isDark={isDark}>Campaign</FieldLabel>
//                     <LuxuryAutocomplete
//                       options={res_get_campaign_data_array}
//                       value={res_get_campaign_data_array.find(i => i._id === campaignid) || null}
//                       onChange={v => setcampaignid(v ? v._id : '')}
//                       placeholder="Select campaign"
//                       isDark={isDark}
//                       getLabel={o => o?.CampainName || ''}
//                       getIcon={() => '📣'}
//                       getSubtitle={() => 'CAMPAIGN'}
//                     />
//                   </div>
//                   <div>
//                     <FieldLabel isDark={isDark}>Channel</FieldLabel>
//                     <LuxuryAutocomplete
//                       options={res_getallchannal_array}
//                       value={res_getallchannal_array.find(i => i._id === Channal) || null}
//                       onChange={v => setchannal(v ? v._id : '')}
//                       placeholder="Select channel"
//                       isDark={isDark}
//                       getIcon={getChannelIcon}
//                       getSubtitle={getChannelSubtitle}
//                     />
//                   </div>
//                 </div>

//                 {/* Communication Way — chips */}
//                 <div>
//                   <FieldLabel isDark={isDark}>Communication Way</FieldLabel>
//                   <div style={{ display:'flex', flexWrap:'wrap', gap:'8px', marginTop:'4px' }}>
//                     {res_getallcommunicationway_array.length > 0
//                       ? [...res_getallcommunicationway_array]
//                           .sort((a,b) => a.name==='No Communication Way'?-1:b.name==='No Communication Way'?1:0)
//                           .slice(0,6)
//                           .map(item => (
//                             <button key={item._id}
//                               onClick={() => setcommunicationwat(Communicationway===item._id?'':item._id)}
//                               style={{
//                                 padding:'7px 16px', borderRadius:'20px', fontSize:'12px',
//                                 fontFamily:T.bodyFont, fontWeight:'500', cursor:'pointer',
//                                 border: Communicationway===item._id ? `1.5px solid ${T.accent}` : `1.5px solid ${isDark?T.darkBorder:T.border}`,
//                                 background: Communicationway===item._id ? T.accentBg : isDark?T.darkSurface2:'#FAFBFF',
//                                 color: Communicationway===item._id ? T.accent : isDark?T.darkMuted:T.textMuted,
//                                 transition:'all .15s',
//                               }}
//                             >{item.name}</button>
//                           ))
//                       : <span style={{ fontSize:'13px', color:isDark?T.darkMuted:T.textLight, fontFamily:T.bodyFont }}>No options available</span>
//                     }
//                   </div>
//                 </div>

//                 {/* Lead Type */}
//                 <div style={{ display:'flex', alignItems:'center', gap:'12px', padding:'12px 14px', background:isDark?T.darkSurface2:T.offWhite, borderRadius:'10px', border:`1.5px solid ${isDark?T.darkBorder:'#EEF1FA'}` }}>
//                   <span style={{ fontSize:'11px', color:isDark?T.darkMuted:T.textMuted, fontWeight:'700', letterSpacing:'1px', textTransform:'uppercase' }}>Lead Type:</span>
//                   <Switch
//                     checked={checked}
//                     onChange={e => setChecked(e.target.checked)}
//                     size="small"
//                     sx={{
//                       '& .MuiSwitch-thumb': { background: checked?T.success:(isDark?T.darkMuted:T.textMuted) },
//                       '& .Mui-checked+.MuiSwitch-track': { background:T.success+'66 !important', opacity:'1 !important' },
//                     }}
//                   />
//                   <span style={{ fontSize:'13px', color:checked?T.success:(isDark?T.darkMuted:T.textMuted), fontWeight:'500' }}>
//                     {checked ? '● Fresh Lead' : '● Cold Lead'}
//                   </span>
//                 </div>

//               </div>
//             </div>

//             {/* ── SECTION 03 / NARRATIVE ── */}
//             <div style={{ background:isDark?T.darkSurface:T.surface, border:`1px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'12px', padding:'28px' }}>
//               <SectionTag number={3} label="Narrative" />
//               <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

//                 <div>
//                   <FieldLabel isDark={isDark}>Job Description (Optional)</FieldLabel>
//                   <textarea value={jobDescription} onChange={e=>setJobDescription(e.target.value)} rows={3}
//                     style={{ ...inputStyle, resize:'vertical', lineHeight:'1.6' }}
//                     placeholder="Professional background..."
//                     onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
//                     onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
//                   />
//                 </div>

//                 <div>
//                   <FieldLabel isDark={isDark}>Budget Allocation (Optional)</FieldLabel>
//                   <div style={{ position:'relative' }}>
//                     <span style={{ position:'absolute', left:'14px', top:'50%', transform:'translateY(-50%)', color:isDark?T.darkMuted:T.textMuted, fontSize:'14px', fontWeight:'600' }}>$</span>
//                     <input value={budget} onChange={e=>setbudget(e.target.value)}
//                       style={{ ...inputStyle, paddingLeft:'30px' }} type="number" placeholder="5,000,000"
//                       onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
//                       onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
//                     />
//                   </div>
//                 </div>

//                 <div>
//                   <FieldLabel isDark={isDark}>Internal Executive Notes (Optional)</FieldLabel>
//                   <textarea value={note} onChange={e=>setNote(e.target.value)} rows={5}
//                     style={{ ...inputStyle, resize:'vertical', lineHeight:'1.6' }}
//                     placeholder="Confidential details regarding lead quality or specific requests..."
//                     onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
//                     onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
//                   />
//                 </div>

//               </div>
//             </div>
//           </div>

//           {/* ══ ACTIONS ══ */}
//           <div style={{ display:'flex', justifyContent:'flex-end', gap:'12px', padding:'8px 0 16px' }}>
//             <button
//               onClick={() => window.history.back()}
//               style={{ padding:'11px 28px', background:'transparent', border:`1.5px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'10px', color:isDark?T.darkMuted:T.textMuted, fontSize:'13px', fontWeight:'500', cursor:'pointer', fontFamily:T.bodyFont, transition:'all .2s' }}
//               onMouseOver={e=>{ e.currentTarget.style.background=isDark?T.darkSurface2:T.offWhite; }}
//               onMouseOut={e=>{  e.currentTarget.style.background='transparent'; }}
//             >
//               Cancel
//             </button>
//             <button
//               onClick={!submitLoading ? onSubmit : undefined}
//               disabled={submitLoading}
//               style={{ padding:'11px 32px', background:T.accent, border:'none', borderRadius:'10px', color:'#fff', fontSize:'13px', fontWeight:'600', cursor:submitLoading?'not-allowed':'pointer', fontFamily:T.bodyFont, display:'flex', alignItems:'center', gap:'8px', opacity:submitLoading?0.75:1, transition:'all .2s' }}
//               onMouseOver={e=>{ if(!submitLoading) e.currentTarget.style.opacity='0.88'; }}
//               onMouseOut={e=>{  if(!submitLoading) e.currentTarget.style.opacity='1'; }}
//             >
//               {submitLoading
//                 ? <><CircularProgress size={16} style={{ color:'white' }} /> Saving Changes...</>
//                 : <><EditIcon style={{ fontSize:'17px' }} /> Save Changes</>
//               }
//             </button>
//           </div>

//           {/* ══ FOOTER BANNER ══ */}
//           <div style={{ borderRadius:'12px', overflow:'hidden', background:`linear-gradient(135deg, ${T.navy} 0%, ${T.navyLight} 40%, #1a2f6e 100%)`, padding:'36px', marginBottom:'8px', position:'relative' }}>
//             <div style={{ position:'absolute', inset:0, opacity:0.06, backgroundImage:'repeating-linear-gradient(45deg, transparent, transparent 20px, rgba(255,255,255,0.4) 20px, rgba(255,255,255,0.4) 21px)' }} />
//             <div style={{ position:'relative', zIndex:1 }}>
//               <div style={{ fontSize:'10px', letterSpacing:'2.5px', color:T.gold, fontWeight:'700', textTransform:'uppercase', marginBottom:'10px', fontFamily:T.bodyFont }}>Executive Principle</div>
//               <blockquote style={{ fontFamily:T.sectionFont, fontSize:'20px', fontWeight:'600', color:'#fff', margin:0, lineHeight:'1.5', fontStyle:'italic' }}>
//                 "Precision in data is the foundation of every elite conversion."
//               </blockquote>
//             </div>
//           </div>

//         </div>

//         {/* Footer */}
//         <footer style={{ padding:'16px 28px', flexShrink:0, fontSize:'12px', color:isDark?'#4b5563':'#9ca3af', fontFamily:T.bodyFont, borderTop:`1px solid ${isDark?T.darkBorder:T.border}`, textAlign:'center' }}>
//           © 2026 Realatix  CRM • Secure Multi-Tenant Architecture
//         </footer>
//       </div>
//     </div>
//   );
// };
















// 24-6-2026


import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { GetOneClientAction, UpdateClientAction } from '../Redux/Actions/UsersAction';
import { Notify } from '../Utility/Notify';
import EditIcon from '@mui/icons-material/Edit';
import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
import { useTheme } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Switch from '@mui/material/Switch';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

/* ─────────────────────────────────────────────
   DESIGN TOKENS
───────────────────────────────────────────── */
const T = {
  navy:        '#0B1437',
  navyLight:   '#0F1D4A',
  navyBorder:  '#0D47A1',
  accent:      '#0D47A1',
  accentBg:    'rgba(26,60,219,0.08)',
  white:       '#FFFFFF',
  offWhite:    '#f0f2f5',
  surface:     '#FFFFFF',
  border:      '#DDE3F0',
  borderLight: '#EEF1FA',
  text:        '#0B1437',
  textMuted:   '#6B7694',
  textLight:   '#9BA5C9',
  gold:        '#C8A96E',
  danger:      '#E24B4A',
  success:     '#1D9E75',
  warning:     '#BA7517',
  labelSize:   '11px',
  sectionFont: "'DM Sans', 'Georgia', sans-serif",
  bodyFont:    "'DM Sans', sans-serif",
  darkBg:      '#0f1117',
  darkSurface: '#1a1d2e',
  darkSurface2:'#161929',
  darkBorder:  '#2a2f45',
  darkText:    '#e5e7eb',
  darkMuted:   '#6b7280',
};

/* ── Google Fonts ── */
if (typeof document !== 'undefined' && !document.getElementById('azure-fonts')) {
  const link = document.createElement('link');
  link.id   = 'azure-fonts';
  link.rel  = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=DM+Sans:wght@300;400;500;600&display=swap';
  document.head.appendChild(link);
}

/* ─────────────────────────────────────────────
   PHONE HELPER
   شيل كل الـ + من الأول وحط + واحدة بس
───────────────────────────────────────────── */
const formatPhone = (v) => {
  if (!v) return '';
  const cleaned = v.replace(/^\++/, '');
  return '+' + cleaned;
};

/* ─────────────────────────
   Mini Components
───────────────────────── */
const SectionTag = ({ number, label }) => (
  <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'20px' }}>
    <div style={{ width:'28px', height:'2px', background: T.accent }} />
    <span style={{
      fontFamily: T.bodyFont, fontSize: T.labelSize, fontWeight:'700',
      letterSpacing:'2px', color: T.accent, textTransform:'uppercase',
    }}>
      Section {String(number).padStart(2,'0')} / {label}
    </span>
  </div>
);

const FieldLabel = ({ children, isDark }) => (
  <label style={{
    display:'block', marginBottom:'6px', fontFamily: T.bodyFont,
    fontSize: T.labelSize, fontWeight:'700', letterSpacing:'1.5px',
    textTransform:'uppercase', color: isDark ? T.darkMuted : T.textMuted,
  }}>
    {children}
  </label>
);

const getInputStyle = (isDark) => ({
  width:'100%', padding:'10px 14px', borderRadius:'10px',
  border:`1.5px solid ${isDark ? T.darkBorder : T.border}`,
  background: isDark ? T.darkSurface2 : '#FAFBFF',
  color: isDark ? T.darkText : T.text,
  fontSize:'13px', fontFamily: T.bodyFont,
  outline:'none', transition:'border-color .2s, box-shadow .2s', boxSizing:'border-box',
  letterSpacing:'0.01em',
});

const SectionCard = ({ children, isDark, style }) => (
  <div style={{
    background: isDark ? T.darkSurface : T.surface,
    border:`1px solid ${isDark ? T.darkBorder : T.border}`,
    borderRadius:'12px', padding:'28px', marginBottom:'20px', ...style,
  }}>
    {children}
  </div>
);

/* ─────────────────────────────────────────────
   LuxuryAutocomplete
───────────────────────────────────────────── */
const getProjectIcon = (name = '') => {
  const n = name.toLowerCase();
  if (n.includes('villa') || n.includes('residence')) return '🏡';
  if (n.includes('beach') || n.includes('leisure') || n.includes('oasis')) return '🏖';
  if (n.includes('commercial') || n.includes('hub') || n.includes('general')) return '🏗';
  if (n.includes('logistic') || n.includes('industrial')) return '🏭';
  if (n.includes('urban') || n.includes('city')) return '🏙';
  if (n.includes('luxury') || n.includes('premium')) return '💎';
  return '🏢';
};

const getProjectSubtitle = (name = '') => {
  const n = name.toLowerCase();
  if (n.includes('villa')) return 'LUXURY LIVING';
  if (n.includes('beach') || n.includes('oasis')) return 'LEISURE ESTATES';
  if (n.includes('commercial') || n.includes('hub')) return 'COMMERCIAL HUB';
  if (n.includes('logistic')) return 'INDUSTRIAL';
  if (n.includes('urban')) return 'URBAN PORTFOLIO';
  if (n.includes('residence') || n.includes('tower')) return 'RESIDENTIAL';
  return 'REAL ESTATE';
};

const LuxuryAutocomplete = ({
  options = [],
  value,
  onChange,
  placeholder,
  loading,
  isDark,
  getLabel,
  getSubtitle,
  getIcon,
  disabled,
}) => {
  const [open,   setOpen]   = useState(false);
  const [search, setSearch] = useState('');
  const ref = React.useRef(null);

  const labelFn    = getLabel    || (o => o?.name || '');
  const subtitleFn = getSubtitle || (o => getProjectSubtitle(o?.name || ''));
  const iconFn     = getIcon     || (o => getProjectIcon(o?.name || ''));

  const filtered = options.filter(o =>
    labelFn(o).toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} style={{ position:'relative', width:'100%' }}>

      {/* Trigger */}
      <div
        onClick={() => !disabled && setOpen(o => !o)}
        style={{
          display:'flex', alignItems:'center', gap:'10px',
          padding:'0 14px', height:'42px', borderRadius:'10px',
          border:`1.5px solid ${open ? T.accent : isDark ? T.darkBorder : T.border}`,
          background: isDark ? T.darkSurface2 : '#FAFBFF',
          cursor: disabled ? 'not-allowed' : 'pointer',
          transition:'border-color .2s, box-shadow .2s',
          boxShadow: open ? `0 0 0 3px rgba(13,71,161,0.08)` : 'none',
          opacity: disabled ? 0.6 : 1,
          userSelect:'none',
        }}
      >
        {value ? (
          <>
            <div style={{
              width:'28px', height:'28px', borderRadius:'7px', flexShrink:0,
              background: isDark ? T.darkBorder : '#EEF1FA',
              display:'flex', alignItems:'center', justifyContent:'center', fontSize:'14px',
            }}>
              {iconFn(value)}
            </div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontSize:'13px', fontWeight:'600', color: isDark?T.darkText:T.text, fontFamily:T.bodyFont, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                {labelFn(value)}
              </div>
              <div style={{ fontSize:'10px', letterSpacing:'1.5px', color:T.accent, fontWeight:'700', fontFamily:T.bodyFont, textTransform:'uppercase' }}>
                {subtitleFn(value)}
              </div>
            </div>
          </>
        ) : (
          <span style={{ fontSize:'13px', color: isDark?T.darkMuted:T.textLight, fontFamily:T.bodyFont }}>
            {placeholder || 'Select...'}
          </span>
        )}
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
          style={{ flexShrink:0, marginLeft:'auto', transition:'transform .2s', transform: open?'rotate(180deg)':'none' }}>
          <path d="M2 4l4 4 4-4" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>

      {/* Dropdown */}
      {open && (
        <div style={{
          position:'absolute', top:'calc(100% + 6px)', left:0, right:0, zIndex:9999,
          background: isDark ? T.darkSurface : '#FFFFFF',
          border:`1.5px solid ${isDark?T.darkBorder:'#DDE3F0'}`,
          borderRadius:'12px',
          boxShadow:'0 12px 40px rgba(11,20,55,0.15)',
          overflow:'hidden', maxHeight:'320px',
          display:'flex', flexDirection:'column',
        }}>

          {/* Search */}
          <div style={{ padding:'10px 12px', borderBottom:`1px solid ${isDark?T.darkBorder:'#EEF1FA'}` }}>
            <div style={{ display:'flex', alignItems:'center', gap:'8px', padding:'8px 12px', borderRadius:'8px', background: isDark?T.darkSurface2:'#F4F6FB' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <circle cx="6" cy="6" r="4.5" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.3"/>
                <path d="M9.5 9.5l2 2" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.3" strokeLinecap="round"/>
              </svg>
              <input
                autoFocus
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder={`Search ${placeholder||'options'}...`}
                style={{ border:'none', outline:'none', background:'transparent', fontSize:'13px', fontFamily:T.bodyFont, flex:1, color: isDark?T.darkText:T.text }}
              />
              {search && (
                <span onClick={() => setSearch('')} style={{ cursor:'pointer', color:isDark?T.darkMuted:T.textLight, fontSize:'16px', lineHeight:1 }}>×</span>
              )}
            </div>
          </div>

          {/* Options */}
          <div style={{ overflowY:'auto', flex:1 }}>
            {loading ? (
              <div style={{ padding:'20px', textAlign:'center', fontSize:'13px', color:isDark?T.darkMuted:T.textMuted, fontFamily:T.bodyFont }}>Loading...</div>
            ) : filtered.length === 0 ? (
              <div style={{ padding:'20px', textAlign:'center', fontSize:'13px', color:isDark?T.darkMuted:T.textMuted, fontFamily:T.bodyFont }}>No results found</div>
            ) : filtered.map((opt, i) => {
              const isSelected = value && labelFn(value) === labelFn(opt);
              return (
                <div
                  key={opt._id || i}
                  onClick={() => { onChange(opt); setOpen(false); setSearch(''); }}
                  style={{
                    display:'flex', alignItems:'center', gap:'12px',
                    padding:'11px 14px', cursor:'pointer',
                    background: isSelected ? (isDark?'rgba(13,71,161,0.15)':'#F0F4FF') : 'transparent',
                    borderLeft: isSelected ? `3px solid ${T.accent}` : '3px solid transparent',
                    transition:'background .12s',
                  }}
                  onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = isDark?'rgba(255,255,255,0.04)':'#F8F9FD'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = isSelected?(isDark?'rgba(13,71,161,0.15)':'#F0F4FF'):'transparent'; }}
                >
                  <div style={{
                    width:'32px', height:'32px', borderRadius:'8px', flexShrink:0,
                    background: isSelected?(isDark?'rgba(13,71,161,0.25)':'#DDEAFF'):(isDark?T.darkBorder:'#EEF1FA'),
                    display:'flex', alignItems:'center', justifyContent:'center', fontSize:'15px',
                  }}>
                    {iconFn(opt)}
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:'13px', fontWeight:isSelected?'600':'500', color:isSelected?T.accent:(isDark?T.darkText:T.text), fontFamily:T.bodyFont, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                      {labelFn(opt)}
                    </div>
                    <div style={{ fontSize:'10px', letterSpacing:'1.2px', fontWeight:'700', color:isSelected?T.accent:(isDark?T.darkMuted:T.textLight), fontFamily:T.bodyFont, textTransform:'uppercase', marginTop:'1px' }}>
                      {subtitleFn(opt)}
                    </div>
                  </div>
                  {isSelected && (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink:0 }}>
                      <circle cx="8" cy="8" r="7" stroke={T.accent} strokeWidth="1.5"/>
                      <path d="M5 8l2 2 4-4" stroke={T.accent} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
              );
            })}
          </div>

          {/* Footer */}
          <div style={{ padding:'10px 14px', textAlign:'center', borderTop:`1px solid ${isDark?T.darkBorder:'#EEF1FA'}` }}>
            <span style={{ fontSize:'11px', letterSpacing:'1.5px', fontWeight:'700', color:T.accent, textTransform:'uppercase', fontFamily:T.bodyFont, cursor:'pointer' }}>
              VIEW ALL ENTITIES
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

/* ─────────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────────── */
export const UpdateClient = () => {
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const { id }       = useParams();
  const dispatch     = useDispatch();
  const sidebarWidth = useSidebarWidth();

  const [userlogin, setuserlogin] = useState(null);
  useEffect(() => {
    try { const u = localStorage.getItem('user'); if (u) setuserlogin(JSON.parse(u)); } catch { setuserlogin(null); }
  }, []);

  const [submitLoading, setSubmitLoading] = useState(false);

  /* ── Date ── */
  const [dateonly, setDateonly] = useState('');
  useEffect(() => {
    const d = new Date();
    setDateonly(`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`);
  }, []);

  /* ── Fields ── */
  const [name,             setName]             = useState('');
  const [email,            setEmail]            = useState('');
  const [note,             setNote]             = useState('');
  const [project,          setproject]          = useState('');
  const [salesdata,        setsalesdata]        = useState('');
  const [loading,          setloading]          = useState(true);
  const [stage,            setstage]            = useState('');
  const [Channal,          setchannal]          = useState('');
  const [Communicationway, setcommunicationwat] = useState('');
  const [budget,           setbudget]           = useState(0);
  const [checked,          setChecked]          = useState(true);
  const [Leedtype,         setLeedtype]         = useState('Fresh');
  const [campaignid,       setcampaignid]       = useState('');
  const [jobDescription,   setJobDescription]   = useState('');

  /* ── Phone ── */
  const [value,               setValue]               = useState('');
  const [phonenumber2,        setphonenumber2]        = useState('');
  const [whatsappnumber,      setwhatsappnumber]      = useState('');
  const [error,               setError]               = useState('');
  const [Errorphonenumber2,   setErrorphonenumber2]   = useState('');
  const [whatsappnumbererror, setwhatsappnumbererror] = useState('');
  const [countryName,         setCountryName]         = useState('');

  const handlePhoneChange = (newValue, countryData) => {
    setValue(newValue); setError('');
    if (countryData) setCountryName(countryData.name);
  };
  const handleBlur = () => {
    const pn = parsePhoneNumberFromString(`+${value}`);
    setError(pn && pn.isValid() ? '' : 'Please enter a valid phone number');
  };
  const handlePhone2Change         = (v) => { setphonenumber2(v);   setErrorphonenumber2('');   };
  const handlewhatsappnumberChange = (v) => { setwhatsappnumber(v); setwhatsappnumbererror(''); };
  const handleBlurphonenumber2     = () => { const p = parsePhoneNumberFromString(`+${phonenumber2}`);   setErrorphonenumber2(p&&p.isValid()?'':'Please enter a valid phone number 2'); };
  const handleBlurwhatsappnumber   = () => { const p = parsePhoneNumberFromString(`+${whatsappnumber}`); setwhatsappnumbererror(p&&p.isValid()?'':'Please enter a valid whatsapp number'); };

  useEffect(() => { setLeedtype(checked ? 'Fresh' : 'Cold'); }, [checked]);

  /* ── Load data ── */
  useEffect(() => {
    const run = async () => {
      await dispatch(GetOneClientAction(id));
      await dispatch(GetallProjectsdata());
      await dispatch(Get_All_Sales_Action());
      await dispatch(GetAll_stage_Data());
      await dispatch(GetAllchannalData());
      await dispatch(GetCommunicationwayData());
      await dispatch(GetAllCampainData());
    };
    run();
  }, []);

  const resone_user_data          = useSelector(s => s.Allusers.Get_users);
  const resGetProjectsData        = useSelector(s => s.AllProjects.Projects);
  const resgetallstages           = useSelector(s => s.Allstages.stage);
  const resgetallchannal          = useSelector(s => s.AllChannalRoot.channal);
  const resgetallcommunicationway = useSelector(s => s.AllCommunicationway.communicationway);
  const resgetcampaindata         = useSelector(s => s.AllCampaign.campaign);
  const ressales                  = useSelector(s => s.AllSales.sales);
  const res                       = useSelector(s => s.Allusers.Get_users);

  const res_getallchannal_array          = Array.isArray(resgetallchannal?.data)          ? resgetallchannal.data          : [];
  const res_getallcommunicationway_array = Array.isArray(resgetallcommunicationway?.data) ? resgetallcommunicationway.data : [];
  const res_get_campaign_data_array      = Array.isArray(resgetcampaindata?.data)         ? resgetcampaindata.data         : [];
  const get_all_Projects_data            = resGetProjectsData?.data || [];

  const one_user_data = resone_user_data?.data || {};

  let salesData = ressales?.data
    ? ressales.data
        .filter(s => !['Default','Default M','Default T','Default S','Developer','Deveolper','Dev'].includes(s.name))
        .sort((a,b) => a.name==='No Sales'?-1:b.name==='No Sales'?1:0)
    : [];

  /* ── Populate fields from fetched lead ── */
  useEffect(() => {
    if (one_user_data && Object.keys(one_user_data).length > 0) {
      setName(one_user_data?.name || '');
      setEmail(one_user_data?.email || '');
      setValue(one_user_data?.phone?.toString() || '');
      setphonenumber2(one_user_data?.phonenumber2?.toString() || '');
      setwhatsappnumber(one_user_data?.whatsappnumber?.toString() || '');
      setJobDescription(one_user_data?.jobdescription || '');
      setNote(one_user_data?.notes || '');
      setproject(one_user_data?.project?._id || '');
      setsalesdata(one_user_data?.sales?._id || '');
      setstage(one_user_data?.stage?._id || '');
      setcommunicationwat(one_user_data?.communicationway?._id || '');
      setcampaignid(one_user_data?.campaign?._id || '');
      setchannal(one_user_data?.chanel?._id || '');
      setbudget(one_user_data?.budget || 0);
      setCountryName(one_user_data?.countryname || '');
      setChecked(one_user_data?.leedtype === 'Fresh');
    }
  }, [one_user_data]);

  /* ── Submit ── */
  const user = (() => { try { return JSON.parse(localStorage.getItem('user')); } catch { return null; } })();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!name)      { Notify('error','Name is Required','Error Message'); return; }
    if (!value)     { Notify('error','Phone is Required','Error Message'); return; }
    if (!salesdata) { Notify('error','Sales is Required','Error Message'); return; }

    setloading(true);
    setSubmitLoading(true);
    await dispatch(UpdateClientAction(id, {
      name, email,
      phone:         formatPhone(value),
      whatsappnumber: formatPhone(whatsappnumber),
      phonenumber2:   formatPhone(phonenumber2),
      project, sales:salesdata, notes:note,
      chanel:Channal, communicationway:Communicationway, leedtype:Leedtype,
      budget, dayonly:dateonly, last_stage_date_updated:dateonly,
      lastdateassign:dateonly, lastcommentdate:'-', updatedby:user?._id,
      jobdescription:jobDescription, campaign:campaignid,
    }));
    setloading(false);
    setSubmitLoading(false);
  };

  useEffect(() => {
    if (loading === false) {
      if (res && res.data) {
        setName(''); setEmail(''); setValue(''); setNote('');
        setwhatsappnumber(''); setphonenumber2(''); setJobDescription('');
        Notify('success','User Updated Successfully','Success Message');
      } else {
        Notify('error','Failed To Update User','Error Message');
      }
      setloading(false);
    }
  }, [loading]);

  /* ── Route helper ── */
  const getHomeRoute = () => {
    switch(userlogin?.data?.role) {
      case 'Admin':    return '/AllLeadsForAdmin';
      case 'Marketer': return '/ALLLeadsForMarketer';
      default:         return '/';
    }
  };

  /* ── Shared styles ── */
  const inputStyle = getInputStyle(isDark);

  const phoneButtonStyle = {
    background: isDark ? T.darkSurface2 : '#F4F6FB',
    border: `1.5px solid ${isDark ? T.darkBorder : T.border}`,
    borderRadius:'10px 0 0 10px', borderRight:'none', padding:'0 10px',
  };
  const phoneDropdownStyle = {
    background: isDark ? T.darkSurface : '#FFFFFF',
    color: isDark ? T.darkText : T.text,
    borderRadius:'10px',
    border:`1.5px solid ${isDark ? T.darkBorder : T.border}`,
    boxShadow:'0 8px 32px rgba(11,20,55,0.12)', marginTop:'4px',
  };
  const phoneInputStyle = {
    ...inputStyle, height:'42px', paddingLeft:'52px',
    borderRadius:'0 10px 10px 0', width:'100%',
  };

  /* ── Channel helpers ── */
  const getChannelIcon = (o) => {
    const n = (o?.name||'').toLowerCase();
    if (n.includes('social')||n.includes('instagram')||n.includes('facebook')) return '📱';
    if (n.includes('email')) return '📧';
    if (n.includes('referral')) return '🤝';
    if (n.includes('web')||n.includes('site')) return '🌐';
    if (n.includes('call')||n.includes('phone')) return '📞';
    if (n.includes('whatsapp')) return '💬';
    return '📡';
  };
  const getChannelSubtitle = (o) => {
    const n = (o?.name||'').toLowerCase();
    if (n.includes('social')) return 'DIGITAL MEDIA';
    if (n.includes('referral')) return 'WORD OF MOUTH';
    if (n.includes('web')) return 'ONLINE';
    if (n.includes('email')) return 'EMAIL MARKETING';
    return 'ACQUISITION CHANNEL';
  };

  const getCommunicationIcon = (o) => {
    const n = (o?.name||'').toLowerCase();
    if (n.includes('whatsapp')) return '💬';
    if (n.includes('call')||n.includes('phone')) return '📞';
    if (n.includes('email')) return '📧';
    if (n.includes('meeting')||n.includes('person')) return '🤝';
    if (n.includes('sms')) return '✉️';
    return '📋';
  };
  const getCommunicationSubtitle = () => 'COMMUNICATION';

  /* ─────────────────────────
     RENDER
  ───────────────────────── */
  return (
    <div style={{
      position:'fixed', top:'50px', left:sidebarWidth, right:0, bottom:0,
      transition:'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      display:'flex', flexDirection:'column', overflow:'hidden',
      backgroundColor: isDark ? T.darkBg : T.offWhite,
      fontFamily: T.bodyFont,
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding:'14px 28px', flexShrink:0,
        backgroundColor: isDark ? T.darkSurface : T.offWhite,
        display:'flex', alignItems:'center', gap:'8px', fontSize:'13px',
      }}>
        <Link to={getHomeRoute()} style={{ textDecoration:'none', color: isDark?'#9ca3af':'#6b7280', fontWeight:'500' }}>
          Home
        </Link>
        <span style={{ color: isDark?'#4b5563':'#d1d5db' }}>/</span>
        <span style={{ color: isDark?'#e5e7eb':'#111827', fontWeight:'600' }}>Update Lead</span>
      </div>

      {/* ── Scrollable Body ── */}
      <div style={{ flex:1, overflowY:'auto', overflowX:'hidden', display:'flex', flexDirection:'column' }}>
        <div style={{ padding:'24px 28px', flex:1 }}>

          {/* Page Heading */}
          <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:'28px' }}>
            <div>
              <div style={{ fontSize:T.labelSize, fontWeight:'700', letterSpacing:'2px', textTransform:'uppercase', color:T.accent, marginBottom:'6px', fontFamily:T.bodyFont }}>
                LEADS / UPDATE
              </div>
              <h1 style={{ fontFamily:T.sectionFont, fontSize:'34px', fontWeight:'700', color:isDark?T.darkText:T.text, margin:'0 0 6px', letterSpacing:'-0.5px' }}>
                Update Lead
              </h1>
              <p style={{ margin:0, fontSize:'14px', color:isDark?T.darkMuted:T.textMuted, fontWeight:'300' }}>
                Modify and refine the lead profile within the system.
              </p>
            </div>
            {/* Lead type badge */}
            <div style={{
              padding:'8px 18px', borderRadius:'20px',
              background: checked ? 'rgba(29,158,117,0.1)' : 'rgba(107,114,128,0.1)',
              border:`1.5px solid ${checked ? T.success : isDark?T.darkBorder:T.border}`,
              display:'flex', alignItems:'center', gap:'8px',
            }}>
              <span style={{ width:'7px', height:'7px', borderRadius:'50%', background: checked?T.success:T.textMuted, display:'inline-block' }} />
              <span style={{ fontSize:'12px', fontWeight:'600', color: checked?T.success:isDark?T.darkMuted:T.textMuted, fontFamily:T.bodyFont, letterSpacing:'0.5px' }}>
                {checked ? 'Fresh Lead' : 'Cold Lead'}
              </span>
            </div>
          </div>

          {/* ══ SECTION 01 / IDENTITY ══ */}
          <SectionCard isDark={isDark}>
            <SectionTag number={1} label="Identity" />
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px' }}>

              <div>
                <FieldLabel isDark={isDark}>Full Name *</FieldLabel>
                <input value={name} onChange={e=>setName(e.target.value)} style={inputStyle}
                  type="text" placeholder="e.g. Alexander Hamilton"
                  onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                  onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                />
              </div>

              <div>
                <FieldLabel isDark={isDark}>Email Address (Optional)</FieldLabel>
                <input value={email} onChange={e=>setEmail(e.target.value)} style={inputStyle}
                  type="email" placeholder="client@private-estate.com"
                  onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                  onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                />
              </div>

              {/* Primary Phone */}
              <div>
                <FieldLabel isDark={isDark}>Primary Phone *</FieldLabel>
                <PhoneInput
                  country={'ae'} value={value}
                  onChange={handlePhoneChange} onBlur={handleBlur}
                  preferredCountries={['ae','us','gb']}
                  inputStyle={phoneInputStyle}
                  buttonStyle={phoneButtonStyle}
                  dropdownStyle={phoneDropdownStyle}
                  containerStyle={{ width:'100%' }}
                />
                {error && <p style={{ marginTop:'6px', fontSize:'12px', color:T.danger, fontFamily:T.bodyFont }}>{error}</p>}
              </div>

              {/* Second Phone */}
              <div>
                <FieldLabel isDark={isDark}>Second Phone (Optional)</FieldLabel>
                <PhoneInput
                  country={'ae'} value={phonenumber2}
                  onChange={handlePhone2Change} onBlur={handleBlurphonenumber2}
                  preferredCountries={['ae','us','gb']}
                  inputStyle={phoneInputStyle}
                  buttonStyle={phoneButtonStyle}
                  dropdownStyle={phoneDropdownStyle}
                  containerStyle={{ width:'100%' }}
                />
                {Errorphonenumber2 && <p style={{ marginTop:'6px', fontSize:'12px', color:T.danger, fontFamily:T.bodyFont }}>{Errorphonenumber2}</p>}
              </div>

              {/* WhatsApp */}
              <div>
                <FieldLabel isDark={isDark}>WhatsApp Number (Optional)</FieldLabel>
                <PhoneInput
                  country={'ae'} value={whatsappnumber}
                  onChange={handlewhatsappnumberChange} onBlur={handleBlurwhatsappnumber}
                  preferredCountries={['ae','us','gb']}
                  inputStyle={phoneInputStyle}
                  buttonStyle={phoneButtonStyle}
                  dropdownStyle={phoneDropdownStyle}
                  containerStyle={{ width:'100%' }}
                />
                {whatsappnumbererror && <p style={{ marginTop:'6px', fontSize:'12px', color:T.danger, fontFamily:T.bodyFont }}>{whatsappnumbererror}</p>}
              </div>

            </div>
          </SectionCard>

          {/* ══ SECTION 02 + 03 ══ */}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px', marginBottom:'20px' }}>

            {/* ── SECTION 02 / ACQUISITION ── */}
            <div style={{ background:isDark?T.darkSurface:T.surface, border:`1px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'12px', padding:'28px' }}>
              <SectionTag number={2} label="Acquisition" />
              <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

                {/* Project */}
                <div>
                  <FieldLabel isDark={isDark}>Project</FieldLabel>
                  <LuxuryAutocomplete
                    options={get_all_Projects_data}
                    value={get_all_Projects_data.find(p => p._id === project) || null}
                    onChange={v => setproject(v ? v._id : '')}
                    placeholder="Select project"
                    isDark={isDark}
                  />
                </div>

                {/* Sales */}
                <div>
                  <FieldLabel isDark={isDark}>Sales *</FieldLabel>
                  <LuxuryAutocomplete
                    options={salesData}
                    value={salesData.find(s => s._id === salesdata) || null}
                    onChange={v => setsalesdata(v ? v._id : '')}
                    placeholder="Select sales"
                    isDark={isDark}
                    getIcon={() => '👤'}
                    getSubtitle={o => {
                      const isMe = o?.userlog?.email === userlogin?.data?.email;
                      return isMe ? 'YOU — SALES AGENT' : (o?.teamleader?.name ? `TEAM: ${o.teamleader.name.toUpperCase()}` : 'SALES AGENT');
                    }}
                  />
                </div>

                {/* Campaign + Channel */}
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
                  <div>
                    <FieldLabel isDark={isDark}>Campaign</FieldLabel>
                    <LuxuryAutocomplete
                      options={res_get_campaign_data_array}
                      value={res_get_campaign_data_array.find(i => i._id === campaignid) || null}
                      onChange={v => setcampaignid(v ? v._id : '')}
                      placeholder="Select campaign"
                      isDark={isDark}
                      getLabel={o => o?.CampainName || ''}
                      getIcon={() => '📣'}
                      getSubtitle={() => 'CAMPAIGN'}
                    />
                  </div>
                  <div>
                    <FieldLabel isDark={isDark}>Channel</FieldLabel>
                    <LuxuryAutocomplete
                      options={res_getallchannal_array}
                      value={res_getallchannal_array.find(i => i._id === Channal) || null}
                      onChange={v => setchannal(v ? v._id : '')}
                      placeholder="Select channel"
                      isDark={isDark}
                      getIcon={getChannelIcon}
                      getSubtitle={getChannelSubtitle}
                    />
                  </div>
                </div>

                {/* Communication Way — chips */}
                <div>
                  <FieldLabel isDark={isDark}>Communication Way</FieldLabel>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:'8px', marginTop:'4px' }}>
                    {res_getallcommunicationway_array.length > 0
                      ? [...res_getallcommunicationway_array]
                          .sort((a,b) => a.name==='No Communication Way'?-1:b.name==='No Communication Way'?1:0)
                          .slice(0,6)
                          .map(item => (
                            <button key={item._id}
                              onClick={() => setcommunicationwat(Communicationway===item._id?'':item._id)}
                              style={{
                                padding:'7px 16px', borderRadius:'20px', fontSize:'12px',
                                fontFamily:T.bodyFont, fontWeight:'500', cursor:'pointer',
                                border: Communicationway===item._id ? `1.5px solid ${T.accent}` : `1.5px solid ${isDark?T.darkBorder:T.border}`,
                                background: Communicationway===item._id ? T.accentBg : isDark?T.darkSurface2:'#FAFBFF',
                                color: Communicationway===item._id ? T.accent : isDark?T.darkMuted:T.textMuted,
                                transition:'all .15s',
                              }}
                            >{item.name}</button>
                          ))
                      : <span style={{ fontSize:'13px', color:isDark?T.darkMuted:T.textLight, fontFamily:T.bodyFont }}>No options available</span>
                    }
                  </div>
                </div>

                {/* Lead Type */}
                <div style={{ display:'flex', alignItems:'center', gap:'12px', padding:'12px 14px', background:isDark?T.darkSurface2:T.offWhite, borderRadius:'10px', border:`1.5px solid ${isDark?T.darkBorder:'#EEF1FA'}` }}>
                  <span style={{ fontSize:'11px', color:isDark?T.darkMuted:T.textMuted, fontWeight:'700', letterSpacing:'1px', textTransform:'uppercase' }}>Lead Type:</span>
                  <Switch
                    checked={checked}
                    onChange={e => setChecked(e.target.checked)}
                    size="small"
                    sx={{
                      '& .MuiSwitch-thumb': { background: checked?T.success:(isDark?T.darkMuted:T.textMuted) },
                      '& .Mui-checked+.MuiSwitch-track': { background:T.success+'66 !important', opacity:'1 !important' },
                    }}
                  />
                  <span style={{ fontSize:'13px', color:checked?T.success:(isDark?T.darkMuted:T.textMuted), fontWeight:'500' }}>
                    {checked ? '● Fresh Lead' : '● Cold Lead'}
                  </span>
                </div>

              </div>
            </div>

            {/* ── SECTION 03 / NARRATIVE ── */}
            <div style={{ background:isDark?T.darkSurface:T.surface, border:`1px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'12px', padding:'28px' }}>
              <SectionTag number={3} label="Narrative" />
              <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

                <div>
                  <FieldLabel isDark={isDark}>Job Description (Optional)</FieldLabel>
                  <textarea value={jobDescription} onChange={e=>setJobDescription(e.target.value)} rows={3}
                    style={{ ...inputStyle, resize:'vertical', lineHeight:'1.6' }}
                    placeholder="Professional background..."
                    onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                    onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                  />
                </div>

                <div>
                  <FieldLabel isDark={isDark}>Budget Allocation (Optional)</FieldLabel>
                  <div style={{ position:'relative' }}>
                    <span style={{ position:'absolute', left:'14px', top:'50%', transform:'translateY(-50%)', color:isDark?T.darkMuted:T.textMuted, fontSize:'14px', fontWeight:'600' }}>$</span>
                    <input value={budget} onChange={e=>setbudget(e.target.value)}
                      style={{ ...inputStyle, paddingLeft:'30px' }} type="number" placeholder="5,000,000"
                      onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                      onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                    />
                  </div>
                </div>

                <div>
                  <FieldLabel isDark={isDark}>Internal Executive Notes (Optional)</FieldLabel>
                  <textarea value={note} onChange={e=>setNote(e.target.value)} rows={5}
                    style={{ ...inputStyle, resize:'vertical', lineHeight:'1.6' }}
                    placeholder="Confidential details regarding lead quality or specific requests..."
                    onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
                    onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
                  />
                </div>

              </div>
            </div>
          </div>

          {/* ══ ACTIONS ══ */}
          <div style={{ display:'flex', justifyContent:'flex-end', gap:'12px', padding:'8px 0 16px' }}>
            <button
              onClick={() => window.history.back()}
              style={{ padding:'11px 28px', background:'transparent', border:`1.5px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'10px', color:isDark?T.darkMuted:T.textMuted, fontSize:'13px', fontWeight:'500', cursor:'pointer', fontFamily:T.bodyFont, transition:'all .2s' }}
              onMouseOver={e=>{ e.currentTarget.style.background=isDark?T.darkSurface2:T.offWhite; }}
              onMouseOut={e=>{  e.currentTarget.style.background='transparent'; }}
            >
              Cancel
            </button>
            <button
              onClick={!submitLoading ? onSubmit : undefined}
              disabled={submitLoading}
              style={{ padding:'11px 32px', background:T.accent, border:'none', borderRadius:'10px', color:'#fff', fontSize:'13px', fontWeight:'600', cursor:submitLoading?'not-allowed':'pointer', fontFamily:T.bodyFont, display:'flex', alignItems:'center', gap:'8px', opacity:submitLoading?0.75:1, transition:'all .2s' }}
              onMouseOver={e=>{ if(!submitLoading) e.currentTarget.style.opacity='0.88'; }}
              onMouseOut={e=>{  if(!submitLoading) e.currentTarget.style.opacity='1'; }}
            >
              {submitLoading
                ? <><CircularProgress size={16} style={{ color:'white' }} /> Saving Changes...</>
                : <><EditIcon style={{ fontSize:'17px' }} /> Save Changes</>
              }
            </button>
          </div>

          {/* ══ FOOTER BANNER ══ */}
          <div style={{ borderRadius:'12px', overflow:'hidden', background:`linear-gradient(135deg, ${T.navy} 0%, ${T.navyLight} 40%, #1a2f6e 100%)`, padding:'36px', marginBottom:'8px', position:'relative' }}>
            <div style={{ position:'absolute', inset:0, opacity:0.06, backgroundImage:'repeating-linear-gradient(45deg, transparent, transparent 20px, rgba(255,255,255,0.4) 20px, rgba(255,255,255,0.4) 21px)' }} />
            <div style={{ position:'relative', zIndex:1 }}>
              <div style={{ fontSize:'10px', letterSpacing:'2.5px', color:T.gold, fontWeight:'700', textTransform:'uppercase', marginBottom:'10px', fontFamily:T.bodyFont }}>Executive Principle</div>
              <blockquote style={{ fontFamily:T.sectionFont, fontSize:'20px', fontWeight:'600', color:'#fff', margin:0, lineHeight:'1.5', fontStyle:'italic' }}>
                "Precision in data is the foundation of every elite conversion."
              </blockquote>
            </div>
          </div>

        </div>

        {/* Footer */}
        <footer style={{ padding:'16px 28px', flexShrink:0, fontSize:'12px', color:isDark?'#4b5563':'#9ca3af', fontFamily:T.bodyFont, borderTop:`1px solid ${isDark?T.darkBorder:T.border}`, textAlign:'center' }}>
          © 2026 Realatix CRM • Secure Multi-Tenant Architecture
        </footer>
      </div>
    </div>
  );
};
